import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { messages, serviceAuthConsts, serviceAuthIcons } from 'app/constants';
import { currency } from 'app/constants/currency.constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { templateTypes } from 'app/constants/templates/template-type';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { CalculationService, DataService, DateService, FormatService, HelperService, HTTPService, SocketService, ValidationService } from 'app/services';

import { ManualOrderedServicePartsComponent } from '../manual-ordered-service-parts/manual-ordered-service-parts.component';
import { SendDialogComponent } from '../send-dialog/send-dialog.component';

import { environment } from 'environments/environment';

import { chargeAccountLimitTooltip } from 'app/constants/csv/constants';
import { WarrantyService } from 'app/services/warranty-service';
import { debounce, find, findIndex, isEqual } from 'lodash';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IDriver } from '../driver-side-list/driver-side-list.interface';

@Component({
  selector: 'app-service-authorisation-dialog',
  templateUrl: './service-authorisation-dialog.component.html',
  styleUrls: ['./service-authorisation-dialog.component.scss'],
  providers: [DialogService],
  encapsulation: ViewEncapsulation.None,
})
export class ServiceAuthorisationDialogComponent implements OnInit {
  isProcessing: boolean = false;
  isReturn: boolean = true;
  estimateId: string = '';
  shopId: string = '';
  authorizedTooltip: string = 'To authorize the pending services, please switch order status to Estimate';
  paymentTooltip: string = 'To collect payment, please first authorize pending services by switching order status to Estimate';
  finalizedTooltip: string = 'Sorry, cannot make changes to a finalized RO';
  order: any = {};
  usd: string = currency.USD;
  serviceStatus: any = {};
  defaultService: any = {};
  hasNegativeBalance: boolean = false;
  hasChanges: boolean = false;
  serviceAuthConsts = serviceAuthConsts;
  serviceAuthIcons = serviceAuthIcons;
  authDate: any = new Date();
  authTime: any = new Date();
  minAuthDate: any = new Date();
  notes: string = '';
  employeeNumberValidationerror: string = '';
  processStepperValue = {
    tabStep: true,
    vehicleInfo: true,
    vehicleInfoBody: false,
    vehicleInfoCompleted: false,
    driverInfoBody: false,
    driverInfoCompleted: false,
    authorization: true,
    authorizationBody: true,
    authorizationCompleted: false,
    processAuthorizedBtn: true,
    partsOrder: false,
    partsOrderBody: true,
    partsOrderCompleted: false,
    tiresDotNumberCompleted: false,
    tiresDotNumberInfoBody: true,
    itemClassificationCompleted: true,
    itemClassificationInfoBody: true,
    salesCodeCompleted: false,
    salesCodeBody: true,
    warrantyCompleted: false,
    warrantyBody: true,
  };
  authMethods: any[] = [
    {
      label: 'In person',
      value: 'inPerson',
      icon: '',
    },
    {
      label: 'Phone',
      value: 'phone',
      icon: '',
    },
    {
      label: 'SMS',
      value: 'sms',
      icon: '',
    },
    {
      label: 'Email',
      value: 'email',
      icon: '',
    },
  ];
  methodValues: any[] = [];
  activeAuthMethod: any = this.authMethods[0];
  unsubscrible: Subject<boolean> = new Subject<boolean>();
  openFrom: string = '';
  hasPendingServices: boolean = false;
  isTireStorageEnabled: boolean = false;
  hasSafeToInvoice: boolean = false;
  isMileageMandatory: boolean = false;
  isVinMandatory: boolean = false;
  requiredVinMilage: boolean = true;
  onlyMileageMandatory: boolean = true;
  onlyVinMandatory: boolean = true;
  data = {
    mileage: '',
    vin: '',
    mileageOut: '',
  };
  defaultData = {
    mileage: '',
    mileageOut: '',
    vin: '',
  };
  focus: any = {};
  errors: any = {};
  adHocMap: any = {};
  serviceTags: any[] = [];
  updateServiceAndTotal = debounce(this._updateServiceAndTotal, 1000);
  updateOrderDetails = debounce(this._updateOrderDetails, 1000);
  defaultTax: any;
  taxes = [];
  customFleetSettings: any = {};
  selectedMethodValue: string = '';
  isManualPartOrderingEnabled = false;
  isPartsTechEnabled = false;
  isNexpartEnabled = false;
  closePartsAccordion = true;
  isPartsOrderingCompleted = false;
  isOrderPlaced = true;
  isCheckServicePending = false;
  hasRequiredServiceCheck = true;
  processingVin: boolean = false;
  isFetchingData: boolean = true;
  isPartsOrderingExist: boolean = false;
  isProcessingAuthorization: boolean = false;
  isProcessingDotNumber: boolean = false;
  isProcessingToQBO: boolean = false;
  isLoading: boolean = false;
  isQboConnected: boolean = false;
  isSyncingToQuickbooks: boolean = false;
  dialogOpenFrom: string = '';
  depositRequest: any = false;
  isTrackMileageInAndOut: boolean = false;
  isDisplayAuthLogs: boolean = false;
  closeCorePartAccordian: boolean = true;
  mileagePlaceholder = '';
  mileageOutPlaceholder = '';
  vinPlaceholder = '';
  hasItemWithCore: boolean = false;
  orderWithCoreItems: any = {
    orderId: '',
    itemsWithCore: [],
  };
  orderItems: any = [];
  isAutoAuthorizeService: boolean = false;
  dialogType: string = '';
  isDotNumberReqOnInv: boolean = false;
  availableLimit = 0;
  isUnlimited: boolean = false;
  tooltip = chargeAccountLimitTooltip;
  isRevenueRecognitionSettleEnabled: boolean = false;
  isChargeAccountEnabled: boolean = false;
  customerId: string = '';
  isFetchingCustomerInfo: boolean = false;
  chargeAccountDetails: any;
  customer: any = {};
  vehicle: any = {};
  disabled: any = {};
  customerHasChargeAccount: boolean = false;
  isNewItemCategoriesEnable: boolean = false;
  isSalesCodeEnabled: boolean = false;
  isPartWarrantiesEnabled: boolean = false;
  subscription: Subscription;
  isFinalizedRo = this.dataService.isFinalizedRo;
  unassignedServices: any[] = [];
  skippedItems: any = {};
  unassignedWarrantyServices: any[] = [];
  skippedWarrantyItems: any = {};
  isMyFleetCenterEnabled: boolean = this.dataService.isMyFleetCenterEnabled && this.dataService.isMyFleetCenterConnected;
  drivers = [];
  isZipCode1Valid: boolean = true;
  addressCityResults: any;
  addressCities = [];
  allCities = [];
  poNumber = '';
  fleetNumber = '';
  authorizeNumber = '';
  authorizedBy = '';
  optionalLabel = 'optional';
  isProcessingDriver = false;
  MFCValidations = false;
  defaultMyFleetValidations = {
    companyName: false,
    poNumber: false,
    authorizeNumber: false,
    fleetNumber: false,
    serviceCardNumber: false,
    fullName: false,
    mileage: false,
    mileageOut: false,
    unitNumber: false,
    licensePlateNo: false,
    vin: false,
    make: false,
    model: false,
    year: false,
  };
  assignedSalesCodeItems: any[] = [];
  MfcSubtitle = '';
  isDisableDriverFormFields: boolean = false;
  optionalMFCValidations = this.helperService.deepCopy(this.defaultMyFleetValidations);
  hasCreditLimitSection: boolean = false;

  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    public helperService: HelperService,
    private httpService: HTTPService,
    private calculationService: CalculationService,
    private dateService: DateService,
    private socketService: SocketService,
    private dialogService: DialogService,
    private formatService: FormatService,
    private dataService: DataService,
    private validationService: ValidationService,
    private warrantyService: WarrantyService,
  ) { }

  ngOnInit() {
    const { data } = this.dynamicDialogConfig.data;
    const { isRevenueRecognitionSettleEnabled } = this.helperService.getCompany();
    this.isRevenueRecognitionSettleEnabled = isRevenueRecognitionSettleEnabled;
    this.isChargeAccountEnabled = this.dataService.isChargeAccountEnabled;
    this.isNewItemCategoriesEnable = this.dataService.isNewItemCategoriesEnable;
    this.isSalesCodeEnabled = this.dataService.isSalesCodeEnabled;
    this.isPartWarrantiesEnabled = this.dataService.isPartWarrantiesEnabled;
    this.shopId = this.helperService.getCompany().shopId;
    this.setSocketListener();
    this.setListner();
    this.inItData(data);

    if (data) {
      if (data.openFrom && data.openFrom !== 'invoice' && data.openFrom !== 'payment') {
        this.hasRequiredServiceCheck = false;
      }

      if (data.checkServicePending) {
        this.isCheckServicePending = data.checkServicePending;
      }

      if (data.payload) {
        const { estimate } = data.payload;
        this.dialogOpenFrom = data.payload.dialogOpenFrom;
        if (estimate && estimate.depositRequest) {
          this.depositRequest = estimate.depositRequest;
        } else {
          this.depositRequest = false;
        }
      }
      this.estimateId = data.estimateId;
      this.openFrom = data.openFrom;
      this.dialogType = data.dialogType;
      this.isAutoAuthorizeService = data?.isAutoAuthorizeService;
      this.getEstimate();
    }

    //Here we have disconnected our QBO Connection
    this.isQboConnected = !!this.helperService.getCompany().qbo;
    if (this.dataService.isCAStateComplianceEnabled && this.dataService.isDisplayAuthorizationLogs) {
      this.isDisplayAuthLogs = true;
    }
    this.isDotNumberReqOnInv = this.dataService.isDotNumberReqOnInv;
  }

  ngOnDestroy() {
    this.unsubscrible.next(true);
    this.unsubscrible.unsubscribe();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  inItData(data) {
    if (data?.serviceData) {
      const { isManualPartOrderingEnabled, isPartsTechEnabled, isNexpartEnabled, serviceTags, depositRequest } = data.serviceData;
      this.serviceTags = serviceTags;
      this.isManualPartOrderingEnabled = isManualPartOrderingEnabled;
      this.isPartsTechEnabled = isPartsTechEnabled;
      this.isNexpartEnabled = isNexpartEnabled;

      if (data.serviceData && data.serviceData.depositRequest) {
        this.depositRequest = depositRequest;
      } else {
        this.depositRequest = false;
      }
    }

    if (data?.MFCValidations) {
      Object.keys(data.MFCValidations).forEach((key) => {
        this.MFCValidations = true;
        if (data.MFCValidations[key] === true) {
          this.defaultMyFleetValidations[key] = true;
        }
      });

      if (!this.dataService.isTrackMileageInAndOut) {
        delete this.defaultMyFleetValidations.mileageOut;
      }
    }
  }

  getUnassignedItemsCount(serviceIdx: number) {
    const unassignedItems: any[] = this.unassignedServices[serviceIdx].items?.filter((item: any) => !item?.salesCode?.salesCodeId) || [];
    return unassignedItems?.length || 0;
  }

  getUnassignedWarrantyItemCount(serviceIdx: number) {
    let unassignedItems: any[] = [];

    if (this.unassignedWarrantyServices[serviceIdx]?.items) {
      this.unassignedWarrantyServices[serviceIdx].items.forEach((item: any) => {
        if (item.type === 'bundle' && item.subItems?.length) {
          // For bundle items, check subItems for unassigned warranties
          const unassignedSubItems = item.subItems.filter((subItem: any) => !subItem?.warranty?.type);
          unassignedItems = unassignedItems.concat(unassignedSubItems);
        } else if (!item?.warranty?.type) {
          // For non-bundle items, check if warranty is not assigned
          unassignedItems.push(item);
        }
      });
    }

    return unassignedItems.length || 0;
  }

  async evaluateAssignedItems(assignedItems: any[]) {
    if (!assignedItems?.length) return;

    const options = {
      isMakeSessionEditable: false,
      browserSessionId: null,
      fetchDriver: true,
    };

    if (this.dialogOpenFrom === 'kanban') {
      options.browserSessionId = Date.now();
      options.isMakeSessionEditable = true;
      this.helperService.setLockOrderSession(
        this.helperService.makeOrderSessionToken(this.estimateId, options.browserSessionId)
      );
    }

    try {
      const order = await this.httpService.getEstimateById(this.estimateId, false, true, options);
      assignedItems.forEach((assignedItem) => this.processAssignedItem(assignedItem, order));
    } catch (error) {
      console.error("Failed to fetch estimate:", error);
    }

    this.processStepperValue.salesCodeCompleted = this.isSalesCodeCompleted();
    this.processStepperValue.warrantyCompleted = this.isWarrantyCompleted();
  }

  processAssignedItem(assignedItem: any, order: any) {
    // if (assignedItem.type === 'warranty') {
    this.processWarrantyItem(assignedItem, order);
    this.processSalesItem(assignedItem, order);
  }

  processWarrantyItem(assignedItem: any, order: any) {
    assignedItem = assignedItem.item || assignedItem;

    const serviceIdx = findIndex(this.unassignedWarrantyServices, { _id: assignedItem?.serviceId });
    const serviceItemIdx = findIndex(order.services, { _id: assignedItem?.serviceId });

    if (serviceIdx > -1 && serviceItemIdx > -1) {
      const itemIdx = findIndex(this.unassignedWarrantyServices[serviceIdx].items, { itemId: assignedItem.itemId });

      let orderItem = order.services[serviceItemIdx].items.find(item => item._id === assignedItem.itemId);

      order.services[serviceItemIdx].items.forEach((subItem) => {
        if ((!orderItem || assignedItem?.isSubItem) && subItem.subItems?.length) {
          orderItem = subItem.subItems.find(item => item._id === assignedItem.itemId);
        }
      });
      if (itemIdx > -1 && orderItem) {
        const currentItem = this.unassignedWarrantyServices[serviceIdx].items[itemIdx];
        const newWarranty = this.helperService.deepCopy(orderItem.warranty || {});

        if (currentItem.warranty?.title) {
          newWarranty.title = currentItem.warranty.title || newWarranty.title;
          newWarranty.warrantySettingId = currentItem.warranty.warrantySettingId || newWarranty.warrantySettingId;
        }

        Object.assign(currentItem, {
          selectedPart: this.helperService.deepCopy(orderItem.selectedPart || {}),
          warranty: newWarranty,
          isWarrantyEligible: false,
          tags: orderItem.tags,
        });
      }

      this.unassignedWarrantyServices[serviceIdx].unassignedItemsCount = this.getUnassignedWarrantyItemCount(serviceIdx);
    }
  }

  processSalesItem(assignedItem: any, order: any) {
    assignedItem = assignedItem.item || assignedItem;

    const serviceIdx = findIndex(this.unassignedServices, { _id: assignedItem?.serviceId });
    const serviceItemIdx = findIndex(order.services, { _id: assignedItem?.serviceId });

    if (serviceIdx > -1 && serviceItemIdx > -1) {
      const itemIdx = findIndex(this.unassignedServices[serviceIdx].items, { itemId: assignedItem.itemId });
      let orderItem = order.services[serviceItemIdx].items.find(item => item._id === assignedItem.itemId);

      order.services[serviceItemIdx].items.forEach((subItem) => {
        if (!orderItem && subItem.subItems?.length) {
          orderItem = subItem.subItems.find(item => item._id === assignedItem.itemId);
        }
      });

      if (itemIdx > -1 && orderItem) {
        const type: string = this.unassignedServices[serviceIdx].items[itemIdx]?.type;
        if (type !== 'bundle') {
          if (orderItem.salesCode) {
            this.unassignedServices[serviceIdx].items[itemIdx].salesCode = {
              ...this.helperService.deepCopy(orderItem.salesCode),
              title: this.helperService.displaySalesCodeTitle(orderItem.salesCode, {}),
            }
          }
          this.unassignedServices[serviceIdx].items[itemIdx].tags = orderItem.tags;
        }
      }

      this.unassignedServices[serviceIdx].unassignedItemsCount = this.getUnassignedItemsCount(serviceIdx);
    }
  }

  isSalesCodeCompleted(): boolean {
    return this.unassignedServices?.every(service =>
      service.items.every(item => item?.salesCode?.salesCodeId)
    );
  }

  isWarrantyCompleted(): boolean {
    return this.unassignedWarrantyServices.every(service =>
      service.items.every(item => item?.warranty?.type)
    );
  }

  setListner() {
    this.subscription = this.dataService.getData().subscribe(({ data }) => {
      if (data && data.key === 'ar-account-limit-updated') {
        if (data.data) {
          this.getCustomerChargeAccountInfo();
        }
      }
      if (data && data.key === 'unassign-partstech-parts-result') {
        if (data.data.isSuccess) {
          this.isReturn = false;
          this.sendInvoice(false);
        } else {
          this.isReturn = true;
        }
      }
      if (data?.key === 'authorization-dialog' && data?.data) {
        this.assignedSalesCodeItems = [...this.assignedSalesCodeItems, ...data?.data?.assignedSalesCodeItems];
        this.evaluateAssignedItems(this.assignedSalesCodeItems || []);
      }
    });
  }

  setSocketListener() {
    this.socketService
      .socketOn(`ORDER_SERVICE_UPDATE_${this.shopId}`)
      .pipe(takeUntil(this.unsubscrible))
      .subscribe((data) => {
        if (data && data.orderId && data.orderId === this.estimateId) {
          this.getEstimate();
        }
      });
  }

  onVehicleDriverSelect(event: any) {
    this.vehicle.driver = { ...event };
    if (event.fullName === 'No driver') {
      this.onUnAssigned();
      this.isDisableDriverFormFields = true;
    } else {
      this.isDisableDriverFormFields = false;
      this.onSubmitVehicleInfo(true);
    }
  }

  onAddDriver(): void {
    const driver: IDriver = {
      isActive: true,
      fullName: '',
      email: '',
      phone: '',
      employeeNumber: '',
      serviceCardNumber: '',
      companyName: '',
      department: '',
      showForm: true,
      customerId: '',
      address: {
        addLine1: '',
        city: '',
        state: '',
        stateCode: '',
        zip: '',
        country: '',
      },
    };
    this.processStepperValue.driverInfoCompleted = false;
    this.vehicle.driver = driver;
    this.isDisableDriverFormFields = false;
  }

  onUnAssigned(): void {
    this.processStepperValue.driverInfoCompleted = false;
    this.onSubmitVehicleInfo();
  }

  handleDriverFormChange(name: string, value: any): void {
    // Support nested properties
    if (!this.vehicle.driver) {
      this.onAddDriver();
    }

    if (name.includes('.')) {
      const [key, subKey] = name.split('.');
      this.vehicle.driver[key] = {
        ...this.vehicle.driver[key],
        [subKey]: value,
      };
    } else {
      if (name === 'fullName' && value) {
        this.vehicle.driver[name] = value;
      }

      if (name !== 'fullName') {
        this.vehicle.driver[name] = value;
      }
    }

    this.processStepperValue.driverInfoCompleted = this.vehicle?.driver?.fullName && !this.getDriverRequiredValidation();

    this.onUpdate();
  }

  getEstimate() {
    if (!this.estimateId) return;

    const options = { isMakeSessionEditable: false, browserSessionId: null, fetchDriver: true };

    if (this.dialogOpenFrom === 'kanban') {
      options.browserSessionId = Date.now();
      options.isMakeSessionEditable = true;
      this.helperService.setLockOrderSession(this.helperService.makeOrderSessionToken(this.estimateId, options.browserSessionId));
    }

    this.httpService.getEstimateById(this.estimateId, false, true, options).then(
      (order) => {
        this.minAuthDate = this.dateService.getCurrentDateTimeTz(new Date(order.createdAt).getTime());
        this.authDate = this.dateService.getCurrentDateTimeTz(order.currentTime);
        this.authTime = this.dateService.getCurrentDateTimeTz(order.currentTime);
        this.order = this.formatOrder(order);
        this.isTireStorageEnabled = this.dataService.isTireStorageEnabled;
        this.isMileageMandatory = this.dataService.isMileageMandatory;
        this.isTrackMileageInAndOut = this.dataService.isTrackMileageInAndOut;
        this.isVinMandatory = this.dataService.enableMandatoryVin;
        this.mileagePlaceholder = `${this.dataService.isTrackMileageInAndOut && this.isMileageMandatory ? 'Mileage in' : 'Mileage'}`;
        this.mileageOutPlaceholder = `Mileage out`;
        this.vinPlaceholder = `VIN`;

        Object.keys(order.MFCValidations).forEach((key) => {
          this.optionalMFCValidations[key] = true;
        });
        this.getRecomendationChecks();
        if (order.vehicle) {
          this.getMileageVinInformation();
        } else {
          this.isFetchingData = false;
        }

        this.initEstimate(order);
        this.initOrder(order);
        if (
          (this.order.manualQoutes?.length > 0 && this.isManualPartOrderingEnabled) ||
          (this.order.nexpartQoutes?.length > 0 && this.isNexpartEnabled) ||
          (this.order.partsTechQoutes?.length > 0 && this.isPartsTechEnabled)
        ) {
          this.isPartsOrderingExist = true;
        }
        if (this.isAutoAuthorizeService) {
          if (this.openFrom !== 'authorize') {
            this.handleAllServiceStatusSelect(serviceAuthConsts.approved);
            if (this.openFrom && this.openFrom !== 'payment') {
              this.defaultService = this.helperService.deepCopy(this.serviceStatus);
            }
          }
        }

        // if (this.isSalesCodeEnabled) {
        //   const { unassignedServiceItems = [], skippedItems = {} } = this.helperService.getUnassignedSalesCodeServiceItems(this.estimateId, this.order.services);
        //   this.unassignedServices = unassignedServiceItems;
        //   this.skippedItems = skippedItems;
        // }

        setTimeout(() => {
          const vehicleRequired = this.getVehicleRequiredValidation();
          const driverRequired = this.getDriverRequiredValidation();
          const authRequired = this.hasPendingServices || this.getAuthenticationRequiredValidation();
          const requiredFields = [];
          if (vehicleRequired) requiredFields.push('Vehicle');
          if (driverRequired) requiredFields.push('Driver');
          if (authRequired) requiredFields.push('Authentication');
          this.MfcSubtitle =
            requiredFields.length > 0 ? `Please complete the required fields in ${requiredFields.join(', ')} to post the invoice to MyFleetCenter.` : 'All required fields are complete.';
        }, 1000);
      },
      (err) => {
        this.isFetchingData = false;
        this.helperService.showToaster('error', err);
      },
    );
  }

  openAssignAllSalesCodeModal(type = 'sales-code') {
    if (type === 'sales-code' && !this.processStepperValue.salesCodeCompleted) {
      this.dataService.sendData(
        this.dataService.typeDialog('open-sales-code-assign-modal', 'authorization-dialog', null, null, {
          isShowMultipleView: true,
          orderId: this.estimateId,
          openFrom: 'authorization-dialog',
          unassignedServices: this.helperService.deepCopy(this.unassignedServices),
          skippedItems: this.helperService.deepCopy(this.skippedItems),
          type,
        }),
      );
    }
    else if (type === 'warranty' && !this.processStepperValue.warrantyCompleted) {
      this.dataService.sendData(
        this.dataService.typeDialog('open-warranty-assign-modal', 'authorization-dialog', null, null, {
          isShowMultipleView: true,
          orderId: this.estimateId,
          openFrom: 'authorization-dialog',
          unassignedServices: this.helperService.deepCopy(this.unassignedWarrantyServices),
          skippedItems: this.helperService.deepCopy(this.skippedWarrantyItems),
          type,
          customerId: this.customerId,
          vehicleId: this.vehicle?._id,
        }),
      );
    }
  }

  getItemsForClassification(services: any[] = []) {
    this.orderItems = [];

    if (services.length) {
      this.orderItems = [];
      services.forEach((service) => {
        if (service.items?.length) {
          service.items.forEach((item: any) => {
            item.serviceId = service._id;
            if (['part', 'labor', 'tire', 'hazmatFee', 'discount', 'tireStorage', 'sublet', 'other'].includes(item.type) && !item.category?.categoryName) {
              this.orderItems.push({
                orderId: this.estimateId,
                itemId: item._id,
                type: item.type,
                title: item.title,
                serviceId: item.serviceId,
                category: item.category,
                salesCode: item.salesCode,
                tags: item.tags,
              });
            } else if (item.type === 'bundle' && item.subItems?.length) {
              item.subItems.forEach((subItem: any) => {
                if (!subItem.salesCode?.categoryName) {
                  this.orderItems.push({
                    orderId: this.estimateId,
                    itemId: item._id,
                    subItemId: subItem._id,
                    type: subItem.type,
                    title: subItem.title,
                    serviceId: item.serviceId,
                    category: subItem.category,
                    salesCode: subItem.salesCode,
                    tags: subItem.tags,
                  });
                }
              });
            }
          });
        }
      });
    }

    this.processStepperValue.itemClassificationCompleted = !this.orderItems.length;
  }

  initOrder(order: any) {
    this.httpService.getOrderInitData(order._id).then(
      (data) => {
        if (data) {
          const { adHocsItems } = data;

          if (adHocsItems && adHocsItems.length) {
            adHocsItems.map((adhocItem: any) => {
              const { orderItemId, itemSource, orderServiceItemId, itemReturnQty, qtyOrdered } = adhocItem;

              if (['PartsTech', 'Nexpart'].includes(itemSource)) {
                this.adHocMap[orderItemId] = { itemReturnQty, qtyOrdered };
              } else {
                this.adHocMap[orderServiceItemId] = { itemReturnQty, qtyOrdered };
              }
            });
          }

          this.setItemsWithCore(order);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  setItemsWithCore(order: any) {
    this.orderWithCoreItems = {
      orderId: '',
      itemsWithCore: [],
    };
    const coreStatusOptions = [
      { name: 'Core: To be retrieved', value: 'toBeRetrieved' },
      { name: 'Core: Retrieved', value: 'retrieved' },
      { name: 'Core: Damaged', value: 'damaged' },
    ];
    this.orderWithCoreItems.orderId = order._id;
    order.services?.forEach(({ title, serviceStatus, items = [] }) => {
      items?.forEach((item: any) => {
        if (item?.hasCore && !['retrieved', 'damaged'].includes(item.coreRetrievalStatus)) {
          if (this.dataService.isCoreFilterEnabled) {
            if (['PartsTech', 'Nexpart'].includes(item.itemSource)) {
              item = { ...item, adhocItem: { ...this.adHocMap[item.orderItemId] } };
            } else {
              item = { ...item, adhocItem: { ...this.adHocMap[item.orderServiceItemId] } };
            }

            if (!(['deferred', 'declined'].includes(serviceStatus) || item.adhocItem?.itemReturnQty > 0 || item.adhocItem?.qtyOrdered == 0)) {
              item.serviceTitle = title;
              item._coreRetrievalStatus = find(coreStatusOptions, { value: item.coreRetrievalStatus || 'toBeRetrieved' });
              this.orderWithCoreItems.itemsWithCore.push(item);
            }
          } else {
            item.serviceTitle = title;
            item._coreRetrievalStatus = find(coreStatusOptions, { value: item.coreRetrievalStatus || 'toBeRetrieved' });
            this.orderWithCoreItems.itemsWithCore.push(item);
          }
        }
      });
    });
    this.hasItemWithCore = this.orderWithCoreItems && this.orderWithCoreItems.itemsWithCore && this.orderWithCoreItems.itemsWithCore.length > 0;
  }

  initEstimate(order) {
    //Service count and auto selected service for PART'S ORDERING
    this.customer = order?.customer?.customerId || order?.customer;
    this.vehicle = order?.vehicle?.vehicleId || order?.vehicle;
    this.disabled.year = this.helperService.trimString(this.vehicle?.year) ? true : false;
    this.disabled.make = this.helperService.trimString(this.vehicle?.make) ? true : false;
    this.disabled.model = this.helperService.trimString(this.vehicle?.model) ? true : false;
    this.customer.otherRequirementTooltip = this.helperService.otherRequirementTooltip();
    this.authorizedBy = this.customer?.MFC?.authorizerDetails?.name || '';
    this.poNumber = order?.poNumber;
    this.authorizeNumber = order?.authorizeNumber;
    this.fleetNumber = order?.fleetNumber ? order?.fleetNumber : this.customer.fleetNumber;
    this.order.manualQoutes = this.setManualQoutes(this.order);
    this.setSelectedService(this.order.services);
    const customer = (order.customer && order.customer.customerId) || {};
    customer.taxExempt = order.customer.taxExempt;
    this.setCustomerDetails({ ...customer, ...order.customer });
    this.defaultTax = {
      parts: order.taxValues.parts,
      labor: order.taxValues.labor,
      tire: order.taxValues.tire,
      tireStorage: order.taxValues.tireStorage,
      other: order.taxValues.other,
      hazmatFee: order.taxValues.hazmatFee,
      preDiscountTax: order.taxValues.preDiscountTax,
      taxRates: order.taxValues.taxRates,
    };

    this.getDriverDetails();
  }

  setCustomerDetails(customer: any) {
    let orderCustomer: any = {
      customerId: customer._id,
      chargeAccountEnable: customer.chargeAccountEnable,
      chargeAccountDetails: customer.chargeAccountDetails,
      fullName: customer.fullName,
      displayName: customer.fullNameQBO,
      isFleetCustomer: customer.isFleetCustomer,
      companyName: customer.companyName,
      email: customer.email,
      phone: customer.phone,
      phone2: customer.phone2,
      notes: customer.notes,
      isEmail: customer.contactOnEmail,
      isSMS: customer.contactOnPhone,
      taxExemptReasonId: customer.taxExemptReasonId,
      taxExempt: customer.taxExempt,
      tags: [],
      contacts: customer.customerId?.contactId.contactInfo || [],
    };

    this.setCustomerContacts(customer.customerId?.contactId.contactInfo);
    // Updating the format of tags
    if (customer.tags && customer.tags.length) {
      orderCustomer.tags = customer.tags.map((tag: any) => ({ ...tag, tagId: tag.categoryId }));
    }

    // If customer is fleet then set it's custom fields for labor rate, order discount, pricing matrix and shop supplies
    this.customFleetSettings = {};
    if (orderCustomer.isFleetCustomer) {
      this.customFleetSettings = {
        isOrderDiscOverride: customer.isOrderDiscOverride,
        isShopSuppliesOverride: customer.isShopSuppliesOverride,
        isLaborRateOverride: customer.isLaborRateOverride,
        isPricingMatrixOverride: customer.isPricingMatrixOverride,
        customLaborRate: customer.customLaborRate,
        customPartPricingMatrix: customer.customPartPricingMatrix,
        customOrderDiscount: customer.customOrderDiscount,
        customShopSupplies: customer.customShopSupplies,
      };

      const { customPartPricingMatrix, customLaborRate, isShopSuppliesOverride, customShopSupplies } = this.customFleetSettings;

      if (isShopSuppliesOverride && this.order.isShopFeeEnabled) {
        this.customFleetSettings.customShopSupplies = customShopSupplies;
      }

      if (customPartPricingMatrix && customPartPricingMatrix._id && !customPartPricingMatrix.pricingId) {
        this.customFleetSettings.customPartPricingMatrix.pricingId = customPartPricingMatrix._id;
      }

      if (customLaborRate && customLaborRate._id && !customLaborRate.pricingId) {
        this.customFleetSettings.customLaborRate.pricingId = customLaborRate._id;
      }

      orderCustomer = { ...orderCustomer, ...this.customFleetSettings };
    }

    this.order.customer = orderCustomer;
    // this.availableLimit = 10000
    this.customerId = this.order.customer.customerId;
    if (this.isChargeAccountEnabled && this.customerId) {
      this.getCustomerChargeAccountInfo();
    }
  }

  setCustomerContacts(contacts) {
    this.selectedMethodValue = '';

    if (this.activeAuthMethod.value === 'sms' || this.activeAuthMethod.value === 'phone') {
      this.methodValues = contacts.filter((element) => element.contactType === 'mobile');
    }
    if (this.activeAuthMethod.value === 'email') {
      this.methodValues = contacts.filter((element) => element.contactType === 'email');
    }
  }

  formatOrder(order: any = {}, isCollapsed = false) {
    if (order.services && order.services.length) {
      order.services.forEach((service: any) => {
        this.serviceStatus[service._id] = service.serviceStatus;

        if (service.items?.length) {
          service.itemCount = {
            part: 0,
            labor: 0,
            tire: 0,
            other: 0,
            tireStorage: 0,
            hazmatFee: 0,
          };

          // service.items.forEach((item: any) => {
          //   service.itemCount[item.type] += item.count;

          //   if (item?.type === 'tire') {
          //     this.formatDotNumberServices(service, item);
          //   }
          //   if (item?.subItems?.length) {
          //     item?.subItems.forEach((sItem: any) => {
          //       if (sItem?.type === 'tire') {
          //         this.formatDotNumberServices(service, sItem);
          //       }
          //     });
          //   }
          // });
        }

        if (service.serviceAuthHistory?.length) {
          service.serviceAuthHistory = this.formatService.formatServiceHistory(service.serviceAuthHistory);
        }
      });

      // order.dotNumberServices = order.services.filter(({ dotNumberItems }) => dotNumberItems?.length);

      // if (order.dotNumberServices?.length) {
      //   this.evaluateTireDotNumber(order.dotNumberServices);
      // } else {
      //   this.processStepperValue.tiresDotNumberCompleted = true;
      // }
    }

    //this.checkForMissingDotNumber(order);
    this.defaultService = this.helperService.deepCopy(this.serviceStatus);
    this.handlePendingServiceCheck();
    this.checkForMissingDotNumber(order);
    if (!isCollapsed) {
      this.stepProcessor('viewAuthorized');
    }
    return order;
  }

  async checkForMissingDotNumber(order: any) {
    if (!order.services?.length) return;

    // Getting tires with unassigned dot numbers
    order.services.forEach((service: any, index: number) => {
      service.dotNumberItems = [];
      if (this.serviceStatus[service._id] && !['pending', 'approved'].includes(this.serviceStatus[service._id])) return;

      if (service.items?.length) {
        service.items.forEach((item: any, itemIndex: number) => {
          if (item?.type === 'tire') {
            this.formatDotNumberServices(service, item);
          }
          if (item?.subItems?.length) {
            item?.subItems.forEach((sItem: any, subItemIndex: number) => {
              if (sItem?.type === 'tire') {
                this.formatDotNumberServices(service, sItem);
              }
            });
          }
        });
      }
    });

    order.dotNumberServices = order.services
      .filter((service: any) => Array.isArray(service.dotNumberItems))
      .map((service: any) => {
        return service.dotNumberItems.length > 0 ? service : null;
      })
      .filter(Boolean);

    if (order.dotNumberServices?.length) {
      this.evaluateTireDotNumber(order.dotNumberServices);
    } else {
      this.processStepperValue.tiresDotNumberCompleted = true;
    }

    // Getting unassigned sales codes
    if (this.isSalesCodeEnabled) {
      const data = this.helperService.getUnassignedSalesCodeServiceItems(this.estimateId, order.services, this.serviceStatus);
      this.unassignedServices = data.unassignedServiceItems || [];
      this.skippedItems = data.skippedItems || {};
    }

    if (this.isPartWarrantiesEnabled) {
      this.warrantyService.processUnassignedWarranties(this.estimateId, order.services, this.serviceStatus, (updatedData) => {
        this.unassignedWarrantyServices = updatedData?.unassignedServiceItems || [];
        this.skippedWarrantyItems = updatedData?.skippedItems || {};
      });
    }


    this.handlePendingServiceCheck();
  }

  evaluateTireDotNumber(dotNumberServices: any) {
    if (dotNumberServices && dotNumberServices?.length) {
      dotNumberServices.forEach((service: any) => {
        if (service.dotNumberItems && service.dotNumberItems.length) {
          service.dotNumberItems.forEach((item: any) => {
            item.validDotNumber = item?.dotNumbers?.every((dot: any) => dot.dotNumber);
            item.containsDotNumber = item?.dotNumbers?.some((dot: any) => dot.dotNumber);

            // if(item.type === 'bundle') {
            //   item.
            // }
          });
          service.validDotNumber = service?.dotNumberItems?.every((dotNumberItem: any) => dotNumberItem?.validDotNumber === true);
          service.containsDotNumber = service?.dotNumberItems?.some((dotNumberItem: any) => dotNumberItem?.containsDotNumber);
        }
      });
      this.processStepperValue.tiresDotNumberCompleted = dotNumberServices.every((service: any) => service.validDotNumber === true);
    }
  }

  evaluateitemClassfication(orderItems: any[] = []) {
    const item = orderItems.find(({ category }) => !category.categoryId);

    if (item) {
      this.processStepperValue.itemClassificationCompleted = false;
    } else {
      this.processStepperValue.itemClassificationCompleted = true;
      this.stepProcessor('itemClassificationInfoBody', false);
    }
  }

  formatDotNumberServices(service: any, item: any) {
    if (!['pending', 'approved'].includes(service.serviceStatus)) return;

    if (!item?.dotNumbers) item.dotNumbers = [];

    if (item?.dotNumbers?.length < item?.count) {
      const newDotNumbers = item.count - item.dotNumbers.length;
      for (let i = 0; i < newDotNumbers; i++) {
        item.dotNumbers.push({ dotNumber: '', tirePosition: '', tooltip: 'Please enter DOT# to specify tire position' });
      }
    } else if (item?.dotNumbers?.length) {
      item.dotNumbers.forEach((dot: any) => {
        if (!dot.dotNumber) {
          dot.tooltip = 'Please enter DOT# to specify tire position';
        } else {
          dot.tooltip = '';
        }
      });
    }

    if (!item?.count && !item?.dotNumbers?.length) {
      item.dotNumbers = [];
    }
    console.log(item.dotNumbers);
    service.dotNumberItems.push(item);
    // console.log('service.dotNumberItems', service.dotNumberItems);
  }

  handlePendingServiceCheck() {
    this.hasPendingServices = Object.values(this.defaultService).includes(serviceAuthConsts.pending);

    if (this.showInvoiceButton()) {
      this.hasPendingServices = Object.values(this.serviceStatus).includes(serviceAuthConsts.pending);
      this.processStepperValue.authorizationCompleted = !this.hasPendingServices && !this.getAuthenticationRequiredValidation();
    }
  }

  handleChange(name: string, value: any) {
    this[name] = value;
    if (name === 'activeAuthMethod') {
      this.setCustomerContacts(this.order.customer.contacts);
    }
    this.processStepperValue.authorizationCompleted = !this.hasPendingServices && !this.getAuthenticationRequiredValidation();
  }

  handleServiceStatusSelect(serviceId: string, serviceStatus: string, serviceIndex: number, isForced: boolean = false, isFromDotPrompt: boolean = false) {
    const deferredStatuses = [serviceAuthConsts.deferred, serviceAuthConsts.deferredLocked, serviceAuthConsts.declined];
    if (!isForced && this.order.services[serviceIndex].timesheet && deferredStatuses.includes(serviceStatus) && !deferredStatuses.includes(this.order.services[serviceIndex].serviceStatus)) {
      this.handleTechTimespentDialog(serviceId, serviceStatus, serviceIndex);
      return;
    } else {
      if (!isFromDotPrompt && deferredStatuses.includes(serviceStatus) && this.serviceStatus[serviceId] !== serviceStatus && this.checkDotNumberValidity(this.order.services[serviceIndex])) {
        this.openDotNumberConfirmationPopup(serviceId, serviceStatus, serviceIndex);
        return;
      } else {
        if (this.serviceStatus[serviceId] === serviceStatus) {
          this.serviceStatus[serviceId] = serviceAuthConsts.pending;
        } else {
          this.serviceStatus[serviceId] = serviceStatus;
        }
      }
    }

    this.order.services[serviceIndex].includeInInvoice = serviceStatus === serviceAuthConsts.approved || serviceStatus === serviceAuthConsts.pending;
    this.checkForMissingDotNumber(this.order);
    this.checkHasChanges();
    this.calculateTotal();
  }

  checkDotNumberValidity(service: any) {
    return service.dotNumberItems && service.dotNumberItems?.length && service.containsDotNumber;
  }

  openDotNumberConfirmationPopup(serviceId: string, serviceStatus: string, serviceIndex: number, isFromAll: boolean = false) {
    let serviceStatusMapper = {
      deferred: 'Deffering',
      deferredLocked: 'Deffering',
      declined: 'Decline',
    };
    const action = serviceStatusMapper[serviceStatus];
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '40%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `${action} this serivce`,
        message: `Service has tires with associated DOT#s. ${action} the service will remove any DOT numbers associated with its tires.
        Would you like to proceed?`,
        button: {
          success: { title: 'Confirm' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        if (isFromAll) {
          this.handleAllServiceStatusSelect(serviceStatus, true);
        } else {
          this.handleServiceStatusSelect(serviceId, serviceStatus, serviceIndex, true, true);
        }
      }

      onClose.unsubscribe();
    });
  }

  handleTechTimespentDialog(serviceId: string, serviceStatus: string, serviceIndex: number) {
    const action = serviceStatus === serviceAuthConsts.deferred ? 'Defer' : 'Decline';
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '40%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `${action} this serivce`,
        message: `There has been work logged against this service. Are you sure you want to ${action}?`,
        button: {
          success: { title: 'Confirm' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.handleServiceStatusSelect(serviceId, serviceStatus, serviceIndex, true);
      }

      onClose.unsubscribe();
    });
  }

  openManualOrderedPartService(item: any) {
    const ref = this.dialogService.open(ManualOrderedServicePartsComponent, {
      width: '445px',
      height: '452px',
      styleClass: `add-dialog item-dialog`,
      showHeader: false,
      data: {
        ...item,
      },
    });
  }

  handleAllServiceStatusSelect(serviceStatus: string, isFromDotPromp: boolean = false) {
    if (this.order.services && this.order.services.length) {
      const deferredStatuses = [serviceAuthConsts.deferred, serviceAuthConsts.deferredLocked, serviceAuthConsts.declined];
      let servicesInvalidDot: any = [];
      this.order.services.forEach((service: any) => {
        if (service.serviceStatus === serviceAuthConsts.pending) {
          if (!isFromDotPromp && this.serviceStatus[service._id] !== serviceStatus && deferredStatuses.includes(serviceStatus) && this.checkDotNumberValidity(service)) {
            servicesInvalidDot.push(service);
          } else {
            if (service.timesheet && [serviceAuthConsts.deferred, serviceAuthConsts.declined].includes(serviceStatus)) {
            } else {
              this.serviceStatus[service._id] = serviceStatus;
              service.includeInInvoice = serviceStatus === serviceAuthConsts.approved;
            }
          }
        }
      });

      if (!isFromDotPromp && servicesInvalidDot?.length) {
        this.openDotNumberConfirmationPopup(null, serviceStatus, null, true);
      }
    }

    this.checkForMissingDotNumber(this.order);
    this.checkHasChanges();
    this.calculateTotal();
  }

  checkHasChanges = () => {
    this.hasChanges = !isEqual(this.serviceStatus, this.defaultService);
  };

  calculateTotal() {
    const tax = {
      parts: this.order.taxValues.parts,
      labor: this.order.taxValues.labor,
      tire: this.order.taxValues.tire,
      tireStorage: this.order.taxValues.tireStorage,
      other: this.order.taxValues.other,
      hazmatFee: this.order.taxValues.hazmatFee,
      tax: this.order.total.tax,
      taxRates: [],
    };

    if (this.order.taxValues) {
      tax.parts = this.order.taxValues.parts;
      tax.labor = this.order.taxValues.labor;
      tax.tire = this.order.taxValues.tire;
      tax.tireStorage = this.order.taxValues.tireStorage;
      tax.hazmatFee = this.order.taxValues.hazmatFee;
      tax.other = this.order.taxValues.other;
      tax.taxRates = this.order.taxValues.taxRates;
    }

    if (this.order.total && this.order.total.tax) {
      tax.tax = this.order.total.tax;
    }

    this.order = this.calculationService.estimateServices(this.order, tax, this.order.total.discount);

    const { total = {}, cheque = 0, card = 0, cash = 0, creditPayment = 0, thirdParty = 0 } = this.order;
    const remainingBalance = total.grand - (cheque + card + cash + creditPayment + thirdParty);

    this.hasNegativeBalance = remainingBalance < 0;
    this.handlePendingServiceCheck();
  }

  formatAuthorizationPayload() {
    const payload = {
      dateTime: '',
      notes: this.notes,
      serviceStatus: this.serviceStatus,
      methodValue: this.selectedMethodValue,
      poNumber: this.poNumber || '',
      authorizeNumber: this.authorizeNumber || '',
      fleetNumber: this.fleetNumber || '',
      method: this.activeAuthMethod.value || '',
    };

    this.defaultService = this.helperService.deepCopy(this.serviceStatus);

    if (this.authTime && this.authDate) {
      const date = this.dateService.formatDate(this.authDate, datetimeFormat.yyymmdd);
      const time = this.dateService.formatDate(this.authTime, datetimeFormat.hhmm);

      payload.dateTime = `${date} ${time}`;
    }

    return payload;
  }

  async handleSubmit(closeDialog: boolean, paymentPayload: any = null) {
    this.stepProcessor('partsOrder');

    // Return if negative balance or another request already in progress
    if (this.hasNegativeBalance) {
      return;
    }

    const dialogFlows = ['invoce', 'payment', 'workflow'];

    if (this.dataService.isCAStateComplianceEnabled && this.dataService.isDisplayAuthorizationLogs) {
      dialogFlows.push('authorize');
    }

    // Return if open dialog while converting status to invoice and still theirs pending services
    if (dialogFlows.includes(this.openFrom)) {
      const serviceStatuses = Object.values(this.serviceStatus);

      if (this.openFrom === 'authorize' && serviceStatuses.includes(serviceAuthConsts.pending)) {
        this.helperService.showToaster('error', messages.authorizeAllServices);
        return;
      }

      if (serviceStatuses.includes(serviceAuthConsts.pending)) {
        this.helperService.showToaster('error', messages.updateServiceAuth);
        return;
      }
    }

    this.isProcessing = true;
    this.isProcessingAuthorization = true;
    let order;
    try {
      order = await this.httpService.updateServiceAuthStatus(this.order._id, this.formatAuthorizationPayload());

      if (order.partsTechParts && order.vehicle?.vehicleId && order.partsTechSessionId && order.partsTechParts.length) {
        const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
          width: '40%',
          styleClass: 'small-heading-dialog',
          showHeader: false,
          data: {
            styleClassHeading: 'font-14',
            title: 'Remove the PartsTech parts from Deferred and declined services',
            message: `Following Part(s) is on deferred list: ${order.partsTechParts.join(', ')}. Do you want to remove these parts from PartsTech cart?`,
            button: {
              success: { title: 'Yes' },
              cancel: { title: 'No' },
            },
          },
        });

        const onClose = ref.onClose.subscribe(async ({ isSuccess, data }) => {
          if (isSuccess) {
            try {
              const res = await this.httpService.createQoute(order._id, order.vehicle.vehicleId);

              window.open(res.redirectUrl, '_self');
            } catch (err) {
              this.helperService.showToaster('error', err);
            }
          }

          this.handleClose(isSuccess, order);
          onClose.unsubscribe();
        });
      } else {
        // refetch data
        this.dataService.sendData(this.dataService.typePassData('payment-list', {}));
        this.processStepperValue.authorizationCompleted = true;
        this.processStepperValue.authorizationBody = false;
        this.isProcessingAuthorization = false;
        this.hasChanges = false;
        this.order = this.formatOrder(order, true);
        closeDialog ? this.handleClose(true) : null;
      }
    } catch (err) {
      this.isProcessingAuthorization = false;
    } finally {
      this.isProcessing = false;
      if (paymentPayload && order.order) {
        this.dataService.sendData(
          this.dataService.typeDialog('add-payment', 'payment-list', null, null, {
            estimate: {
              ...order.order,
              fulEstimateObject: paymentPayload?.fulEstimateObject,
              customer: paymentPayload.customer,
              estimateId: order.order._id,
              dialogType: this.dialogType,
            },
          }),
        );
      }
    }
  }

  handleClose(isSuccess: boolean = false, data: any = {}, isDiscardChanges: boolean = false, paymentPayload: any = null) {
    if (!this.MFCValidations) {
      if (!isDiscardChanges && (!isEqual(this.serviceStatus, this.defaultService) || (!isEqual(this.data, this.defaultData) && this.validateVehicleInfoStatus()))) {
        this.handleDiscardChanges(paymentPayload);
        return true;
      }
    }

    if (data) {
      data.postToMyFleetCenter = false;
    }

    isDiscardChanges = isDiscardChanges ? false : isSuccess;

    this.dynamicDialogRef.close({ isDiscardChanges, data });

    if (this.dialogOpenFrom === 'kanban') {
      this.httpService
        .updateOrderRestriction(this.estimateId, { status: 'readOnly' })
        .then((res) => { })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  // THIS IS VEHICLE INFO
  getRecomendationChecks() {
    //  in case modal is open from authorization;
    if (!this.hasRequiredServiceCheck || !this.order.vehicle?.name) {
      this.requiredVinMilage = false;
      return;
    }
    if (!this.isMileageMandatory && !this.isVinMandatory) {
      this.requiredVinMilage = false;
    } else if (this.isMileageMandatory && !this.isVinMandatory) {
      this.onlyVinMandatory = false;
    } else if (this.isVinMandatory && !this.isMileageMandatory) {
      this.onlyMileageMandatory = false;
    } else if (this.openFrom === 'payment') {
      this.requiredVinMilage = false;
    } else {
      this.requiredVinMilage = true;
    }
  }

  handleFocus(type: string) {
    this.focus[type] = true;
  }

  handleBlur(type: string) {
    this.focus[type] = false;

    if (type === 'address') {
      this.populateCityByZipCode(type);
    }
    if (type === 'phone') {
      if (!this.vehicle.driver.phone) {
        this.errors.phone = '';
      }
    }
  }

  handleChangeVin(type: string, value: string) {
    this.data[type] = value;
    if (this.data.vin) {
      this.errors.vin = '';
    }
    if (this.data.mileage) {
      this.errors.mileage = '';
    }
    if (this.data.mileageOut) {
      this.errors.mileageOut = '';
    }
    if (this.validateVehicleInfoStatus()) {
      this.processStepperValue.vehicleInfoCompleted = true;
    } else {
      this.processStepperValue.vehicleInfoCompleted = false;
    }
  }

  handleChangeFleetVehicle(type: string, value: string) {
    this.vehicle[type] = value;
  }

  handleChangeInput(isMyFleet = false) {
    if (isMyFleet) {
      this.onSubmitVehicleInfo();
    } else {
      this.onSubmitMilage();
    }
  }

  getMileageVinInformation() {
    this.httpService
      .getMileageVinInformation(this.order._id)
      .then(({ VIN, mileage, mileageOut }: any) => {
        if (VIN) {
          this.data.vin = VIN;
        } else {
          this.focus.vin = this.isVinMandatory;
        }

        if (mileage) {
          this.data.mileage = mileage;
        } else if (!this.focus.vin) {
          this.focus.mileage = this.isMileageMandatory;
        }

        if (mileageOut && this.isTrackMileageInAndOut) {
          this.data.mileageOut = mileageOut;
        } else if (!this.focus.mileage) {
          this.focus.mileageOut = this.isTrackMileageInAndOut;
        }

        //  set step for vehicle info here
        if (this.validateVehicleInfoStatus()) {
          this.stepProcessor('vehicleInfo');
        }
        //  if Modal is invoice and milage and vin checks required
        this.stepProcessor('requiredVinMilageStep');
        this.isFetchingData = false;
        this.defaultData = { ...this.data };
      })
      .catch((err) => {
        this.isFetchingData = false;
      });
  }

  handleValidate(): boolean {
    let isValid = true;

    if (this.hasRequiredServiceCheck && this.isMileageMandatory && !this.data.mileage) {
      // this.errors.mileage = `Mileage ${this.dataService.isTrackMileageInAndOut ? 'in' : ''} is mandatory *`;
      isValid = false;
    }

    if (this.hasRequiredServiceCheck && this.isTrackMileageInAndOut && !this.data.mileageOut) {
      // this.errors.mileageOut = 'Mileage out is mandatory *';
      isValid = false;
    }

    if (this.isTrackMileageInAndOut && this.data.mileageOut) {
      if (Number(this.data.mileage) > Number(this.data.mileageOut)) {
        this.errors.mileageOut = 'Mileage out cannot be less than Mileage in';
        isValid = false;
      }
    }

    if (this.hasRequiredServiceCheck && this.isVinMandatory && !this.data.vin) {
      // this.errors.vin = 'VIN is mandatory *';
      isValid = false;
    }

    return isValid;
  }

  onSubmitMilage(isForceUpdate: boolean = false, isUpdateAcrossSystem: boolean = true, isSavingWithoutValidation: boolean = false) {
    if (!this.handleValidate() && !isSavingWithoutValidation) return;
    const data = { isForceUpdate, isUpdateAcrossSystem, mileage: '', vin: '', mileageOut: '' };

    data.mileage = this.data.mileage;
    data.vin = this.data.vin;
    data.mileageOut = this.data.mileageOut;

    if (!data.isForceUpdate && data.isUpdateAcrossSystem) {
      this.processingVin = true;
    }

    this.defaultData = { ...this.data };
    this.validateVehicleInfoStatus();
    this.httpService
      .updateMileageVinInformation(this.estimateId, data)
      .then(
        (data: any) => {
          this.defaultData = { ...this.data };
          if (data.invalidMileage) {
            const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
              width: '30%',
              styleClass: 'small-heading-dialog',
              showHeader: false,
              data: {
                styleClassHeading: 'font-14',
                title: 'Update the vehicle mileage across the system',
                message: `Current vehicle mileage for ${data.name || ''} is ${data.prevMileage},\
                  which is greater than the mileage entered on the RO.
                  Do you want to update this mileage across the system?`,
                button: {
                  success: { title: 'Yes' },
                  cancel: { title: 'No' },
                },
              },
            });

            const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
              this.onSubmitMilage(true, isSuccess);

              onClose.unsubscribe();
            });

            return;
          }
          this.dataService.sendData(this.dataService.typePassData('update-invoice-service', this.order));

          if (this.validateVehicleInfoStatus()) {
            this.processStepperValue.vehicleInfoCompleted = true;
            this.stepProcessor('authorization');
          } else {
            this.processStepperValue.vehicleInfoCompleted = false;
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.processingVin = false;
      });
  }

  onSubmitVehicleInfo(isDriverUpdate = false) {
    const { year, make, model, unitNumber, licensePlateNo, _id, driver } = this.vehicle;
    const vehicle: any = {
      year,
      make,
      model,
      unitNumber,
      licensePlateNo,
      name: `${year || ''} ${make || ''} ${model || ''}`,
      customerId: this.customerId,
      _id,
    };

    if (isDriverUpdate) {
      this.isProcessingDriver = true;
    } else {
      this.processingVin = true;
    }

    if (this.vehicle.driver && !this.validateDriver(this.vehicle.driver)) {
      return;
    }

    if (driver?.fullName && driver?.fullName !== 'No driver') {
      vehicle.driver = {
        driverId: driver._id,
        name: driver.fullName,
        ...driver,
      };

      this.processStepperValue.driverInfoCompleted = this.vehicle?.driver?.fullName && !this.getDriverRequiredValidation();
    } else {
      vehicle.driver = null;
      this.processStepperValue.driverInfoCompleted = false;
    }

    this.httpService
      .updateVehicle(vehicle)
      .then((response) => {
        if (this.validateVehicleInfoStatus()) {
          this.processStepperValue.vehicleInfoCompleted = true;
          this.stepProcessor('authorization');
        } else {
          this.processStepperValue.vehicleInfoCompleted = false;
        }
      })
      .finally(() => {
        this.isProcessingDriver = false;
        this.processingVin = false;
      });
  }

  stepProcessor(type?, setDefaultData?) {
    // Helper function to update processStepperValue based on type
    const updateProcessStepperValue = (updates) => {
      this.processStepperValue = { ...this.processStepperValue, ...updates };
    };

    if (setDefaultData) {
      if (type === 'vehicleInfoBody') {
        this.data = { ...this.defaultData };
        this.processStepperValue.vehicleInfoCompleted = this.validateVehicleInfoStatus();
      } else if (type === 'authorizationBody') {
        this.serviceStatus = this.helperService.deepCopy(this.defaultService);
        this.checkHasChanges();
      }
    }

    if (type) {
      const isAuthorization = type === 'authorization';
      const isAuthorizationBody = type === 'authorizationBody';
      const isDriverInfoBody = type === 'driverInfoBody';
      const isVehicleInfo = type === 'vehicleInfo';
      const isViewAuthorized = type === 'viewAuthorized';
      const isRequiredVinMilageStep = type === 'requiredVinMilageStep';

      this.processStepperValue[type] = !this.processStepperValue[type];

      if (isAuthorization || isAuthorizationBody) {
        updateProcessStepperValue({
          tabStep: true,
          authorization: true,
        });

        if (isAuthorization) {
          updateProcessStepperValue({
            vehicleInfoBody: false,
          });
        }
      }

      if (isDriverInfoBody) {
        updateProcessStepperValue({
          tabStep: true,
          driverInfoCompleted: !(this.getDriverRequiredValidation() || !this.vehicle?.driver?.fullName),
        });
      }

      if (type === 'vehicleInfo') {
        this.processStepperValue = {
          ...this.processStepperValue,
          tabStep: true,
          vehicleInfo: true,
          vehicleInfoBody: false,
          vehicleInfoCompleted: true,
          authorization: true,
          authorizationBody: this.order.services && this.order.services.length > 0 ? this.hasPendingServices || this.getAuthenticationRequiredValidation() : true,
          authorizationCompleted: this.order.services && this.order.services.length > 0 ? !this.hasPendingServices && !this.getAuthenticationRequiredValidation() : false,
          processAuthorizedBtn: false,
        };
      }
      if (type === 'viewAuthorized') {
        this.processStepperValue = {
          ...this.processStepperValue,
          tabStep: true,
          vehicleInfo: true,
          vehicleInfoBody: !this.validateVehicleInfoStatus(),
          vehicleInfoCompleted: this.validateVehicleInfoStatus(),
          authorization: true,
          authorizationBody: this.order.services && this.order.services.length > 0 ? this.hasPendingServices || this.getAuthenticationRequiredValidation() : true,
          authorizationCompleted: this.order.services && this.order.services.length > 0 ? !this.hasPendingServices && !this.getAuthenticationRequiredValidation() : false,
          processAuthorizedBtn: false,
        };
      }
      //  required only for Invoice and in case of Vin and Milage required
      if (type === 'requiredVinMilageStep') {
        this.processStepperValue = {
          ...this.processStepperValue,
          vehicleInfoBody: !this.validateVehicleInfoStatus(),
          vehicleInfoCompleted: this.validateVehicleInfoStatus(),
          authorization: true,
          authorizationBody: this.order.services && this.order.services.length > 0 ? this.hasPendingServices || this.getAuthenticationRequiredValidation() : true,
          authorizationCompleted: this.order.services && this.order.services.length > 0 ? !this.hasPendingServices && !this.getAuthenticationRequiredValidation() : false,
          processAuthorizedBtn: true,
        };
      }

      return;
    }

    if (this.processStepperValue.vehicleInfo) {
      updateProcessStepperValue({
        tabStep: true,
        vehicleInfo: true,
        authorization: true,
        processAuthorizedBtn: false,
      });
    }
  }

  //END THIS IS VEHICLE INFO

  /*
   PARTS ORDERING START
  Here we are only using functions for parts ordering
*/
  setPartsTechQoutes(estimate: any) {
    const partsTechQoutes = [];

    // Fetching qoutes from current PartsTech cart
    if (estimate.partsTechQoute) {
      const { orders = [] } = estimate.partsTechQoute;
      const qoute = {
        id: 'current',
        isOrderPlaced: estimate.isOrderPlaced,
        isOrderDelivered: estimate.isOrderDelivered,
        quoteCreatedAt: '',
        partsTechLastSynced: '',
        partsTechOrderPlacedAt: '',
      };

      if (estimate.quoteCreatedAt) {
        qoute.quoteCreatedAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(estimate.quoteCreatedAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
      }

      if (estimate.partsTechLastSynced) {
        qoute.partsTechLastSynced = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(estimate.partsTechLastSynced).getTime()), datetimeFormat.mmmdyyhhmmaa);
      }

      if (estimate.partsTechOrderPlacedAt) {
        qoute.partsTechOrderPlacedAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(estimate.partsTechOrderPlacedAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
      }

      if (!estimate.isOrderPlaced) {
        this.isOrderPlaced = false;
      }

      if (orders.length > 0) {
        partsTechQoutes.push({ ...estimate.partsTechQoute, ...qoute });
      }
    }

    // Fetching qoutes from old PartsTech cart
    if (estimate.oldPartsTechQoutes && estimate.oldPartsTechQoutes.length) {
      estimate.oldPartsTechQoutes.forEach(({ _id, isOrderPlaced, partsTechQoute, quoteCreatedAt, partsTechLastSynced, partsTechOrderPlacedAt, isOrderDelivered }) => {
        const { orders = [] } = partsTechQoute;
        partsTechQoute.id = _id;
        partsTechQoute.isOrderPlaced = isOrderPlaced;
        partsTechQoute.isOrderDelivered = isOrderDelivered;

        if (quoteCreatedAt) {
          partsTechQoute.quoteCreatedAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(quoteCreatedAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
        }

        if (partsTechOrderPlacedAt) {
          partsTechQoute.partsTechOrderPlacedAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(partsTechOrderPlacedAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
        }

        if (partsTechLastSynced) {
          partsTechQoute.partsTechLastSynced = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(partsTechLastSynced).getTime()), datetimeFormat.mmmdyyhhmmaa);
        }

        if (!isOrderPlaced) {
          this.isOrderPlaced = false;
        }

        partsTechQoutes.push(partsTechQoute);
        //here we update the count if method is called from MANUAL PARTS ORDER;
      });
    }
    //here we update the count if method is called from MANUAL PARTS ORDER;
    return partsTechQoutes;
  }

  setManualQoutes = (estimate: any) => {
    const manualQoutes = [];

    // Fetching qoutes from current Manual Order
    if (estimate.manualQoute && estimate.manualQoute.qoute) {
      const { orders = [] } = estimate.manualQoute.qoute;
      const qoute = {
        id: 'current',
        isOrderPlaced: estimate.manualQoute.isOrderPlaced,
        createdAt: estimate.manualQoute.createdAt,
        updateAt: estimate.manualQoute.updateAt,
        orderedAt: estimate.manualQoute.orderedAt,
      };

      if (qoute.createdAt) {
        qoute.createdAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(qoute.createdAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
      }

      if (qoute.updateAt) {
        qoute.updateAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(qoute.updateAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
      }

      if (qoute.orderedAt) {
        qoute.orderedAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(qoute.orderedAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
      }

      if (!qoute.isOrderPlaced) {
        this.isOrderPlaced = false;
      }

      manualQoutes.push({ ...estimate.manualQoute, ...qoute });
    }

    // Fetching qoutes from old PartsTech cart
    if (estimate.oldManualQoute && estimate.oldManualQoute.length) {
      estimate.oldManualQoute.forEach((manualQoute: any) => {
        const { isOrderPlaced, createdAt, updateAt, orderedAt } = manualQoute;
        const { orders = [] } = manualQoute.qoute;
        // qoute.id = _id;
        if (createdAt) {
          manualQoute.createdAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(createdAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
        }

        if (orderedAt) {
          manualQoute.orderedAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(orderedAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
        }

        if (updateAt) {
          manualQoute.updateAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(updateAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
        }

        if (!isOrderPlaced) {
          this.isOrderPlaced = false;
        }

        manualQoutes.push(manualQoute);
      });
    }
    return manualQoutes;
  };

  setNexpartQoutes(estimate: any) {
    const nexpartQoutes = [];
    // Fetching qoutes from current PartsTech cart
    if (estimate.nexpartQoute) {
      const { lastSyncAt, quoteCreatedAt, orderPlacedAt, quote = {}, accountId, isOrderPlaced, sessionId, apiToken, isOrderDelivered, paymentDetails } = estimate.nexpartQoute;

      if (quote?.Cart?.BranchCart) {
        const data = {
          accountId,
          sessionId,
          apiToken,
          isOrderPlaced,
          id: 'current',
          isOrderDelivered,
          lastSyncAt: '',
          orderPlacedAt: '',
          quoteCreatedAt: '',
          paymentDetails,
          orders: quote?.Cart?.BranchCart?.filter(({ Id }) => Id),
        };

        if (quoteCreatedAt) {
          data.quoteCreatedAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(quoteCreatedAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
        }

        if (lastSyncAt) {
          data.lastSyncAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(lastSyncAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
        }

        if (orderPlacedAt) {
          data.orderPlacedAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(orderPlacedAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
        }
        if (!isOrderPlaced) {
          this.isOrderPlaced = false;
        }

        nexpartQoutes.push({ ...data });
      }
      estimate.oldNexpartQoute.forEach((qoute: any) => {
        const { lastSyncAt, quoteCreatedAt, orderPlacedAt, quote = {}, accountId, isOrderPlaced, sessionId, apiToken, isOrderDelivered, paymentDetails } = qoute;
        const data = {
          accountId,
          sessionId,
          isOrderPlaced,
          id: 'current',
          apiToken,
          nexpart: false,
          lastSyncAt: '',
          orderPlacedAt: '',
          quoteCreatedAt: '',
          isOrderDelivered,
          paymentDetails,
          orders: quote?.Cart?.BranchCart?.filter(({ Id }) => Id),
        };

        if (quoteCreatedAt) {
          data.quoteCreatedAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(quoteCreatedAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
        }

        if (lastSyncAt) {
          data.lastSyncAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(lastSyncAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
        }

        if (orderPlacedAt) {
          data.orderPlacedAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(orderPlacedAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
        }
        if (!isOrderPlaced) {
          this.isOrderPlaced = false;
        }

        nexpartQoutes.push({ ...data });
      });
    }

    return nexpartQoutes;
  }

  checkOrderPlace({ checkOrderPlaced, manualOrder }) {
    this.isOrderPlaced = checkOrderPlaced ? false : true;
    this.order.manualQoutes = manualOrder;
    this.dataService.sendData(this.dataService.typePassData('update-invoice-service', manualOrder));
    if (this.isOrderPlaced) {
      this.closePartsAccordion = false;
    }
  }

  setSelectedService(services: any[]) {
    this.order.nexpartQoutes = this.setNexpartQoutes(this.order);
    this.order.partsTechQoutes = this.setPartsTechQoutes(this.order);

    if (this.isOrderPlaced) {
      this.closePartsAccordion = false;
    }
  }

  setReturnCoreForPartOrdering = (data: any) => {
    if (data._id) {
      if (this.order.services && this.order.services.length) {
        for (let h = 0; h < this.order.services.length; h++) {
          const { items = [] } = this.order.services[h];

          for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (item.orderItemId && data.orderItemId && item.orderItemId === data.orderItemId) {
              item.coreCost = data.coreCost;
              item.qtyReturn = data.itemReturnQty;
              item.hasCore = !!data.coreCost;
              item.hasReturn = !!data.itemReturnQty;

              if (item.tags) {
                item.tags = item.tags.filter(({ name }) => !['Core', 'Returned'].includes(name));
              }

              if (item.hasCore) {
                const coreTag = find(this.serviceTags, { name: 'Core' });
                coreTag.tooltip = `Core: $${Number(item.coreCost).toFixed(2)}`;
                if (coreTag) item.tags.push(coreTag);
              }

              if (item.hasReturn) {
                const returnTag = find(this.serviceTags, { name: 'Returned' });
                returnTag.tooltip = `Qty returned: ${Number(item.qtyReturn)}`;
                if (returnTag) item.tags.push(returnTag);
              }
              // this.updateServiceAndTotal();
              return;
            }
          }
        }
      }
    }
  };

  _updateServiceAndTotal(openPaymentModal: boolean = false, replaceService: boolean = false, updateAdjustment: boolean = false, triggerFrom: string = '', updateServiceRef: boolean = false) {
    if (environment.isMock) {
      return;
    }

    this.calculateAllTotal(triggerFrom);
    this._updateServicesAndTotal(openPaymentModal, replaceService, updateAdjustment, updateServiceRef);
  }

  /** Calculate All Service Total */
  calculateAllTotal(event?: any) {
    if (this.order.customer.taxExempt) {
      this.defaultTax.tax = find(this.taxes, ['name', 'Exempt - 0%']);

      if (this.defaultTax.tax && this.defaultTax.tax.taxRates && this.defaultTax.tax.taxRates.length) {
        this.defaultTax.taxRates = this.defaultTax.tax.taxRates;
      } else {
        this.defaultTax.taxRates = [];
      }

      if (!this.defaultTax.tax) {
        this.defaultTax.tax = { name: 'Tax Exempt', salesTaxRate: 0 };
        this.defaultTax.taxRates = [];
      }
    }

    const previousTotal = this.order.total.grand;
    let estimate = this.helperService.deepCopy(this.order);
    let currentDiscount = this.helperService.deepCopy(estimate.total.discount);
    let currentShopSupplies = this.helperService.deepCopy(estimate.total.shopSupplyFee);

    let orderDiscountItems = this.helperService.deepCopy(estimate.total.orderDiscountItems) || [];
    let preTaxFee = this.helperService.deepCopy(estimate.total.preTaxFee) || [];

    estimate = this.calculationService.estimateServices(estimate, this.defaultTax, estimate.total.discount);

    this.order.total.preTaxFee = [...(preTaxFee || [])];
    this.order.total.orderDiscountItems = [...(orderDiscountItems || [])];

    this.order = this.calculationService.estimateServices(this.order, this.defaultTax, this.order.total.discount);
  }

  _updateOrderDetails(isMileageUpdated: boolean = false, forceMileageUpdate: boolean = false, updateGlobalMileage: boolean = true) {
    const updateEstimate: any = {
      title: this.order.title,
      customer: { ...this.order.customer, ...(this.customFleetSettings || {}) },
      vehicle: this.order.vehicle,
      shopNotes: this.order.shopNotes,
      customerNotes: this.order.customerNotes,
      forceMileageUpdate,
      updateGlobalMileage,
      priority: this.order.priority,
    };

    if (isMileageUpdated) {
      updateEstimate.mileage = this.order.reading;
    }

    if (this.order.tags && this.order.tags.length) {
      this.order.tags.forEach((tag: any) => {
        if (tag._id) {
          tag.tagId = tag._id;
        }
      });
    }

    updateEstimate.tags = this.order.tags || [];
    this.httpService
      .updateOrderDetails(this.order._id, updateEstimate)
      .then(
        (order: any) => {
          if (order.invalidMileage) {
            const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
              width: '30%',
              styleClass: 'small-heading-dialog',
              showHeader: false,
              data: {
                styleClassHeading: 'font-14',
                title: 'Update the vehicle mileage across the system',
                message: `Current vehicle mileage for ${(this.order.vehicle && this.order.vehicle.name) || ''}
               is ${order.prevMileage}, which is greater than the mileage entered on the RO.
              Do you want to update this mileage across the system?`,
                button: {
                  success: { title: 'Yes' },
                  cancel: { title: 'No' },
                },
              },
            });

            const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
              if (isSuccess) {
                this._updateOrderDetails(true, true);
              } else {
                this._updateOrderDetails(true, true, false);
              }

              onClose.unsubscribe();
            });

            return;
          }

          if (order.isRoLevelFeeEnabled) {
            this.order.total.preTaxFee = [...(order.total.preTaxFee || [])];
          }

          if (order.isDiscountItemEnabled) {
            this.order.total.orderDiscountItems = [...(order.total.orderDiscountItems || [])];
          }

          if (order.vehicleMileage) {
            this.order.reading = order.vehicleMileage.reading || '';
            this.order.vehicleMileage = order.vehicleMileage;
            // this.defaultRepairOrder.vehicleMileage = order.vehicleMileage;
          } else {
            this.order.reading = '';
            this.order.vehicleMileage = '';
            // this.defaultRepairOrder.vehicleMileage = '';
          }

          // if (updateEstimate.customer && updateEstimate.customer.customerId) {
          //   this.isCustomerSelected = true;
          // }

          // if (updateEstimate.vehicle && updateEstimate.vehicle.vehicleId) {
          //   this.isVehicleSelected = true;
          // }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        // this.isOrderDetailsUpdating = false;
      });
  }

  makeServicesToUpdate() {
    const services = [];
    const estimateServices = this.helperService.deepCopy(this.order.services);

    estimateServices.forEach((service: any) => {
      const newService = this.helperService.deepCopy(service);

      if (!newService.category) {
        newService.category = {};
      }

      newService.items = [];

      if (service.items) {
        service.items.forEach((item: any) => {
          item = this.helperService.deepCopy(item);
          item.isvalid = true;

          const { type, title, price, itemId } = item;

          if (type && type !== 'other' && !itemId) {
            item.isvalid = false;
          }

          if (type && title && !isNaN(price) && item.isvalid) {
            newService.items.push(item);
          }
        });

        if (newService.items) {
          services.push(this.helperService.deepCopy(newService));
        }
      }
    });

    return services;
  }
  replaceOrderService(order: any) {
    if (order) {
      const titles = {};
      const inspections = {};
      const { services, total } = order;

      this.order.services.forEach(({ _id, title, inspection }) => {
        titles[_id] = title;
        inspections[_id] = inspection;
      });

      services.forEach((ser: any, serviceIndex: number) => {
        const { items } = ser;

        if (items && items.length) {
          items.forEach((item: any, itemIndex: number) => {
            if (['labor', 'part', 'tire'].includes(item.type) && !item.itemId) {
              services[serviceIndex].items[itemIndex].itemId = item._id;
            }
          });
        }

        if (titles[ser._id]) {
          ser.title = titles[ser._id];
          ser.inspection = inspections[ser._id];
        }
      });

      this.order.total = this.helperService.deepCopy(total);
      this.order.services = this.helperService.deepCopy(services);
      // this.defaultRepairOrder.total = this.helperService.deepCopy(total);
      // this.defaultRepairOrder.services = this.helperService.deepCopy(services);
    }
  }
  _updateServicesAndTotal(openPaymentModal: boolean = false, replaceService: boolean = false, updateAdjustment: boolean = false, updateServiceRef: boolean = false) {
    const estimate: any = {
      _id: this.order._id,
      services: this.makeServicesToUpdate(),
      total: this.order.total,
      taxRates: this.order.taxValues.taxRates,
      billableHours: this.order.billableHours,
      totalCost: this.order.totalCost,
      isShopFeeEnabled: this.order.isShopFeeEnabled,
      isFinalized: this.order.isFinalized,
    };
    // here we updating the nexpart data in RO Parts Ordering tab

    if (updateAdjustment && !this.order.adjustments) {
      estimate.adjustments = {};
    } else if (updateAdjustment && this.order.adjustments) {
      estimate.adjustments = this.order.adjustments;
      estimate.isShopFeeEnabled = this.order.isShopFeeEnabled;
    }

    if (updateServiceRef) {
      this.order.services = [...this.order.services];
    }

    this.httpService.updateOrderServices(estimate._id, estimate, openPaymentModal).then(
      (order: any) => {
        this.order.isSyncedWithQBO = false;
        this.dataService.sendData(this.dataService.typePassData('update-authorization-order', order.services));
        this.order.totalRetrievedCoreCost = order.totalRetrievedCoreCost;
        this.setSelectedService(order.services);
        if (replaceService) {
          this.replaceOrderService(order);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  addPartsTechPartToService({ service, item }) {
    let serviceIndex = -1,
      oldItem = null;

    this.order.services.forEach(({ _id, items }: any, sIndex: number) => {
      if (_id === service._id) {
        serviceIndex = sIndex;
      }

      items.forEach((pItem: any, iIndex: number) => {
        if (`${pItem.orderItemId}` === `${item.orderItemId}`) {
          oldItem = pItem;
          this.order.services[sIndex].items.splice(iIndex, 1);
        }
        if (!pItem.itemId) {
          pItem.itemId = 'no-id';
        }
      });
    });

    if (serviceIndex >= 0) {
      if (oldItem) {
        item.discount = oldItem.discount;
      }
      const index = this.order.services[serviceIndex].items.length - 1;
      this.order.services[serviceIndex].items.splice(index, 0, item);
      // this.order.services[serviceIndex].items.map(res=>{
      //   if(!res.itemId){
      //     res.itemId='no-id'
      //   }
      // })
      this.order.services[serviceIndex].items = [...this.order.services[serviceIndex].items];
    }

    this._updateServiceAndTotal(false, false);
  }

  syncPartsTechParts(parts: any) {
    this.order.services.forEach((service: any, sIndex: number) => {
      service.items.forEach((item: any, iIndex: number) => {
        if (item.itemSource === 'PartsTech' && item.orderItemId) {
          const part = parts[item.orderItemId];

          if (part.isOrderPlaced) return;

          if (!part) {
            this.order.services[sIndex].items[iIndex].isDeleted = true;
          } else {
            if (item.isPriceChanged) {
              part.price = item.price;
            }

            /**
             * @todo to verify calculations from parts tech and alp item
             */
            if (item.discount && item.discount.value) {
              part.discount = item.discount;
            }

            this.order.services[sIndex].items.splice(iIndex, 1, {
              ...item,
              ...part,
              isTaxable: item.isTaxable,
            });
          }
        }
      });
    });

    this.order.services.forEach((service: any) => {
      service.items = service.items.filter(({ isDeleted }) => !isDeleted);
    });
    this._updateServiceAndTotal(false, true);
  }

  generateActivity(data: any) {
    data.moduleId = this.order._id;
    this.httpService.generateOrderActivityLogFromClient(data).then(
      (res) => { },
      (err) => { },
    );
  }

  handleClosePartsAccordion() {
    this.closePartsAccordion = !this.closePartsAccordion;
  }

  async checkPartsOrdering() {
    this.isLoading = true;
    const estimate = this.helperService.deepCopy(this.order);
    estimate.orderStatus = 'invoice';
    const payload = {
      authorizationPayload: this.formatAuthorizationPayload(),
      orderStatus: estimate.orderStatus,
      customerId: estimate.customer && estimate.customer.customerId,
      updateWorkflow: true,
      forcedUpdate: false,
    };
    const result = await this.httpService
      .updateOrderStatus(this.order._id, payload)
      .then(
        (order: any) => {
          this.isLoading = false;
          // this.postCustomEvent(estimate);
          if (order.status === 'part-ordering') {
            if (estimate.partstechStatus !== 'noAssociated') {
              this.dataService.sendData(
                this.dataService.typePassData('unassign-partstech-parts', {
                  type: 'RO',
                  payload: {
                    orderId: estimate._id,
                    action: 'status',
                    ...order,
                    ...estimate,
                  },
                }),
              );
              this.isReturn = true;
            }
          } else {
            this.isReturn = false;
          }
          return this.isReturn;
        },
        (err) => {
          console.log(err);
        },
      )
      .finally(() => {
        this.isLoading = false;
      });
    return result;
  }

  allValidation() {
    if (this.order && this.order.customer && this.order.customer.customerId) {
    } else {
      this.helperService.showToaster('error', 'Please select customer');
      return true;
    }
  }

  trackPXWarrantyEvents(order: any) {
    const itemType: any = {
      part: 'Part',
      tire: 'Tire',
    };
    if (this.dataService.isPartWarrantiesEnabled && order?.invoiced) {
      if (order?.services?.length) {
        let warrantyEligibleItems: any[] = [];
        order.services.forEach((service: any) => {
          if (service?.items?.length) {
            warrantyEligibleItems = [
              ...warrantyEligibleItems,
              ...service.items.filter((item: any) => {
                return item?.isWarrantyEligible && item?.warranty?.warrantySettingId;
              }),
            ];
          }
        });

        if (warrantyEligibleItems?.length) {
          let eventArray = warrantyEligibleItems.map((itemEligible: any) => {
            const dateTimeObj = this.dateService.getCurrentDateTimeTz(new Date(order?.invoiceDate).getTime());

            return {
              tenantName: this.helperService.getCompany().companyName,
              warrantySettingsName: itemEligible?.warranty.title || '',
              invoiceDate: this.dateService.formatDate(dateTimeObj, datetimeFormat.mmmdyyyy),
              invoicedAt: this.dateService.getTime(dateTimeObj),
              warrantyType: itemEligible?.warranty?.type || '',
              itemType: itemType[itemEligible?.type] || '',
            };
          });

          if (eventArray?.length) {
            const eventObj = {
              warrantyEligibleItems: eventArray,
            };
            (<any>window).aptrinsic('track', 'Warranty Eligible Items Invoiced', eventObj);
          }
        }
      }
    }
  }

  async sendInvoice(saveQuickBook: boolean) {
    if (this.isLoading) return;

    //this.isLoading = true;

    if (this.allValidation()) {
      return;
    }

    if (this.isReturn) {
      if (await this.checkPartsOrdering()) {
        if (this.isReturn) {
          return;
        }
      }
    }

    const estimate = this.helperService.deepCopy(this.order);
    estimate.orderStatus = 'invoice';
    const payload = {
      authorizationPayload: this.formatAuthorizationPayload(),
      orderStatus: estimate.orderStatus,
      customerId: estimate.customer && estimate.customer.customerId,
      updateWorkflow: true,
      forcedUpdate: true,
      hasSafeToInvoice: this.hasSafeToInvoice,
    };
    // this.handleChangeInput();
    this.isSyncingToQuickbooks = true;
    this.isProcessingToQBO = true;
    this.isLoading = true;
    this.httpService
      .updateOrderStatus(this.order._id, payload)
      .then(
        async (order: any) => {
          this.dataService.sendData(this.dataService.typePassData('update-invoice-service', order));

          this.trackPXWarrantyEvents(order);
          this.handleClose();
          this.postCustomEvent(estimate);
          this.postDVICustomEvent(estimate);
          this.isLoading = false;
          this.isProcessingToQBO = false;

          if (saveQuickBook) {
            this.saveToQuickBook();
          }
          if (order?._id) {
            const ref = this.dialogService.open(SendDialogComponent, {
              width: '45%',
              styleClass: 'add-dialog send-dialog modal-stretched',
              showHeader: false,
              data: {
                openFrom: 'RO',
                data: order,
                title: 'Invoice',
                customer: order.customer,
                vehicle: order.vehicle?.vehicleId,
                cash: order.cash,
                cheque: order.cheque,
                card: order.card,
                creditPayment: order.creditPayment,
                thirdParty: order.thirdParty,
                templateType: templateTypes.invoice,
              },
            });

            const onClose = ref.onClose.subscribe((close: any) => {
              if (close && close._id) {
                if (close.isPickupScheduled) {
                  this.order.isPickupScheduled = close.isPickupScheduled;
                  this.order.pickupDate = close.pickupDate;
                }
              }
              onClose.unsubscribe();
            });
          } else {
            this.helperService.showToaster('error', order?.status);
          }

        },
        (err: any) => {
          this.isLoading = false;
          if (typeof err === 'string') {
            this.isProcessingToQBO = false;
            this.dataService.sendData({
              type: 'app-toaster',
              status: 'error',
              message: {
                heading: 'Error',
                body: err,
              },
            });
            if (err.indexOf('Tire storage details required before invoicing') > -1) {
              this.handleClose();
            }
          } else {
            this.isProcessingToQBO = false;
            this.dataService.sendData({
              type: 'app-toaster',
              status: 'error',
              message:
                err.data && err.data.message
                  ? {
                    heading: 'Error',
                    body: err.data && err.data.message,
                  }
                  : err.msg,
            });
          }
        },
      )
      .finally(() => {
        this.isLoading = false;
      });
  }

  postCustomEvent(estimate) {
    if (this.dataService.isGainSightPXEnabled) {
      const serviceItemsDetails = this.getServiceItemsDetails(estimate.services);
      if (serviceItemsDetails.itemsCount > 0) {
        const catalogItemsInRO: any = {
          customerName: estimate.customer?.fullName || '',
          vehicleName: estimate.vehicle?.name || '',
          estimateNumber: estimate?.code || '',
          estimateName: estimate?.title || '',
          itemsCount: serviceItemsDetails.itemsCount,
          itemsTypes: serviceItemsDetails.itemsTypes,
          itemsNames: serviceItemsDetails.itemsNames,
        };

        (<any>window).aptrinsic('track', 'Catalog Items in RO', catalogItemsInRO);
      }
    }
  }

  postDVICustomEvent(estimate) {
    if (this.dataService.isGainSightPXEnabled && Object.keys(estimate.inspections).length) {
      const dviROInvoiced: any = {
        inspectionsCount: Object.keys(estimate.inspections).length,
        inspectionsName: this.getAttachedInspections(estimate.services),
        roNumber: estimate.code,
        customerName: estimate.customer?.fullName,
        vehicleName: estimate.vehicle?.name,
      };

      (<any>window).aptrinsic('track', 'DVI RO Invoiced', dviROInvoiced);
    }
  }

  getServiceItemsDetails(services) {
    const details = {
      itemsCount: 0,
      itemsTypes: '',
      itemsNames: '',
    };
    if (services.length) {
      services.forEach((service) => {
        if (service.items?.length) {
          service.items.forEach((item) => {
            if (item.type === 'part' || item.type === 'labor' || item.type === 'tire' || item.type === 'hazmatFee' || item.type === 'bundle' || item.type === 'discount') {
              details.itemsCount = details.itemsCount + 1;
              details.itemsTypes += !details.itemsTypes ? `${item.type}` : `, ${item.type}`;
              details.itemsNames += !details.itemsNames ? `${item.title}` : `, ${item.title}`;
            }
          });
        }
      });
    }
    return details;
  }

  getAttachedInspections(services) {
    let inspectionNames = '';
    services.forEach((element) => {
      if (element.inspection && element.inspection.inspectionId) {
        inspectionNames += !inspectionNames ? `${element.inspection.inspectionId.title}` : `, ${element.inspection.inspectionId.title}`;
      }
    });

    return inspectionNames;
  }

  openPaymentDialog() {
    let estimate = this.order;
    if (this.order && this.order.order && this.order.order.customer) {
      estimate = this.order.order;
    }
    if (estimate && estimate.customer && estimate.customer.customerId) {
      const data = {
        _id: estimate._id,
        fulEstimateObject: estimate,
        title: estimate.title,
        code: estimate.code,
        isPaidFull: estimate.isPaidFull,
        cash: estimate.total?.cash,
        cheque: estimate.total?.cheque,
        card: estimate.total?.card,
        creditPayment: estimate.total?.creditPayment,
        thirdParty: estimate.total?.thirdParty,
        total: estimate.total && estimate.total,
        work: estimate.total && estimate.total,
        workFlowStatus: estimate.workFlowStatus,
        authorized: estimate.authorized,
        vehicleInfo: {
          vin: this.data.vin,
          milage: this.data.mileage,
          milageOut: this.data.mileageOut,
        },
        // authorizationStatus = "unapproved"
        // authorized = false
        customer: {
          customerId: estimate.customer && estimate.customer.customerId,
          fullName: estimate.customer && estimate.customer.fullName,
          email: estimate.customer && estimate.customer.email,
          phone: estimate.customer && estimate.customer.phone,
          chargeAccountDetails: estimate.customer && estimate.customer.chargeAccountDetails,
          chargeAccountEnable: estimate.customer && estimate.customer.chargeAccountEnable,
        },
        dialogType: this.dialogType,
      };
      if (!this.isMileageMandatory) {
        delete data.vehicleInfo.milage;
        delete data.vehicleInfo.milageOut;
      }
      if (!this.isTrackMileageInAndOut) {
        delete data.vehicleInfo.milageOut;
      }
      if (!this.isVinMandatory) {
        delete data.vehicleInfo.vin;
      }
      if (data._id) {
        const isConfirmationRequired = this.handleClose(false, {}, false, data);
        if (!isConfirmationRequired) {
          this.dataService.sendData(this.dataService.typeDialog('add-payment', 'payment-list', null, null, { estimate: data }));
        }
      }
    } else {
      this.helperService.showToaster('error', 'Please select customer first!');
    }
  }

  sendInvoiceToQBO() {
    this.syncWithQuickbooks();
  }

  checkServiceHasItem(services = [], total: any) {
    let serviceErrorMsg = false;
    let itemErrorMsg = false;
    // if grand is grather then 0 the allow user to POST to QBO
    if (total.grand > 0) return { serviceErrorMsg, itemErrorMsg };
    for (let serviceIndex = 0; serviceIndex < services.length; serviceIndex++) {
      const service = services[serviceIndex];
      if (service.includeInInvoice) {
        for (let itemIndex = 0; itemIndex < service.items.length; itemIndex++) {
          const item = service.items[itemIndex];
          if (item.type) return { serviceErrorMsg, itemErrorMsg };
        }
      }
      serviceErrorMsg = true;
    }
    return { serviceErrorMsg, itemErrorMsg: !serviceErrorMsg };
  }

  syncWithQuickbooks = async () => {
    const { total, services } = this.order;

    const { serviceErrorMsg, itemErrorMsg } = this.checkServiceHasItem(services, total);
    if (itemErrorMsg) {
      this.helperService.showToaster('error', 'Please add at least 1 item to post Invoice to QBO');
      return;
    }
    if (serviceErrorMsg) {
      this.helperService.showToaster('error', 'As all the services in the invoice are deferred or declined, we cannot post this invoice to QBO');
      return;
    }
    await this.sendInvoice(true);
  };

  saveToQuickBook() {
    this.isSyncingToQuickbooks = true;
    this.isProcessingToQBO = true;
    this.httpService.syncCompleteInvoiceInQBO(this.order._id).then(
      (res: any) => {
        if (res.msg.discontinueQuickbooksCardPayPosting) {
          this.dataService.sendData({
            type: 'app-toaster',
            status: 'success',
            message: {
              heading: 'Invoice has been successfully posted',
              body: `<div>Posting of card payments has been turned "Off"</div><div>Contact AutoLeap support for help</div>`,
            },
          });
        } else {
          this.dataService.sendData(this.dataService.typePassData('update-invoice-service', res));
          this.helperService.showToaster('success', 'Successfully posted to Quickbooks');
        }
        this.isProcessingToQBO = false;
      },
      (err) => {
        if (typeof err === 'string') {
          this.isProcessingToQBO = false;
          this.dataService.sendData({
            type: 'app-toaster',
            status: 'error',
            message: {
              heading: 'Error',
              body: err,
            },
          });
        } else {
          this.isProcessingToQBO = false;
          this.dataService.sendData({
            type: 'app-toaster',
            status: 'error',
            message:
              err.data && err.data.message
                ? {
                  heading: 'Error',
                  body: err.data && err.data.message,
                }
                : err.msg,
          });
        }
      },
    );
  }

  //here we showing Cancel button in bottom left in MODAL
  showLeftCancel = () => this.showInvoiceButton();

  //here we showing Cancel button in bottom Right in MODAL
  showRightCancel = () => this.showAuthorizeButton() || this.showPaymentButton() || this.MFCValidations;

  //To validate Form
  isValidate = () => {
    const { isArchived, vehicle } = this.order || {};
    const { authorizationCompleted, vehicleInfoCompleted, tiresDotNumberCompleted,
      salesCodeCompleted, warrantyCompleted } = this.processStepperValue || {};

    const isServiceCheckValid = !this.hasRequiredServiceCheck && (this.isProcessing || isArchived || !this.hasChanges);
    const isPendingServicesCheck = this.hasRequiredServiceCheck && this.hasPendingServices && !this.isProcessing;
    const isAuthorizationViewValid = isArchived || this.openFrom === 'invoice' || this.openFrom === 'payment';

    const isAuthorizationIncomplete = !authorizationCompleted;
    const isVehicleInfoIncomplete = !vehicleInfoCompleted && this.requiredVinMilage && vehicle;
    const isTiresDotNumberIncomplete = !tiresDotNumberCompleted && this.isDotNumberReqOnInv;
    const isSalesCodeIncomplete = !salesCodeCompleted && this.isSalesCodeEnabled && this.isNewItemCategoriesEnable && this.unassignedServices.length;
    const isWarrantyIncomplete = !warrantyCompleted && this.isPartWarrantiesEnabled && this.unassignedWarrantyServices.length;

    // Group all invoice or payment-related validations
    const isInvoiceOrPaymentIncomplete =
      isAuthorizationViewValid && (isAuthorizationIncomplete || isVehicleInfoIncomplete || isTiresDotNumberIncomplete || isSalesCodeIncomplete
        || isWarrantyIncomplete
        || this.isValidSafeToInvoice());
    //|| (!this.processStepperValue.itemClassificationCompleted && this.isNewItemCategoriesEnable)

    // Final validation check
    return isServiceCheckValid || isPendingServicesCheck || isInvoiceOrPaymentIncomplete;
  };

  validateVehicleInfoStatus = () => {
    const { vin, mileage, mileageOut } = this.data;
    const { unitNumber, licensePlateNo, make, model, year } = this.vehicle || {};
    const { onlyMileageMandatory, onlyVinMandatory, isTrackMileageInAndOut, isCheckServicePending } = this;
    const isFieldEmpty =
      (!mileage || (isTrackMileageInAndOut && !mileageOut) || !vin || !unitNumber || !licensePlateNo || !make || !model || !year) &&
      this.customer?.isMFCustomer &&
      this.MFCValidations &&
      this.customer?.isFleetCustomer;

    if (
      (!isCheckServicePending && onlyMileageMandatory && mileage && !onlyVinMandatory) ||
      (onlyVinMandatory && vin && !onlyMileageMandatory) ||
      (onlyVinMandatory && vin && onlyMileageMandatory && mileage) ||
      (vin && onlyMileageMandatory && mileage) ||
      (isTrackMileageInAndOut && mileageOut && onlyMileageMandatory && mileage)
    ) {
      if (isTrackMileageInAndOut && !mileageOut) {
        return false;
      }

      if (onlyVinMandatory && !vin) {
        return false;
      }

      if (isTrackMileageInAndOut && mileageOut && Number(mileage) > Number(mileageOut)) {
        if (Number(mileage) > Number(mileageOut)) this.errors.mileageOut = 'Mileage out cannot be less than Mileage in';
        return false;
      }

      if (this.getVehicleRequiredValidation()) {
        return false;
      } else {
        if (isFieldEmpty) {
          return false;
        }
      }
      return true;
    }
  };

  handleDiscardChanges(paymentPayload: any = null) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `Would you like to save changes?`,
        message: `There are unsaved changes here. Would you like to save them before leaving this page?`,
        button: {
          success: { title: 'Save changes and exit' },
          cancel: { title: 'Discard changes' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        if (this.validateVehicleInfoStatus()) {
          this.onSubmitMilage(false, true, true);
        }
        this.handleSubmit(true, paymentPayload);
      } else {
        this.handleClose(null, null, true);
        if (paymentPayload) {
          this.dataService.sendData(this.dataService.typeDialog('add-payment', 'payment-list', null, null, { estimate: paymentPayload }));
        }
      }
      onClose.unsubscribe();
    });
  }

  // Open customer side modal
  openCustomerSidebar(event) {
    if (event) {
      const customer = this.helperService.deepCopy(this.order.customer);
      customer._id = this.order.customer.customerId;
      customer.action = 'select-finance';
      customer.estimateId = this.order._id;
      customer.estimate = this.helperService.deepCopy(this.order);

      this.dataService.sendData(this.dataService.typeSidebar('customer', customer.customerId, customer.fullName, customer));
      // this.cdr.detectChanges();
    }
  }

  /*
   PARTS ORDERING END
*/

  // Charge Account info
  async getCustomerChargeAccountInfo() {
    if (this.customerId) {
      try {
        this.isFetchingCustomerInfo = true;
        const customer: any = await this.httpService.getCustomerChargeAccountDetails(this.customerId, { chargeAccountDetails: true });

        if (customer?.chargeAccountEnable && customer?.chargeAccountDetails) {
          this.customerHasChargeAccount = customer.chargeAccountEnable;
          let allowedLimit = customer.chargeAccountDetails?.allowedLimit || 0;
          this.isUnlimited = customer.chargeAccountDetails?.unlimited || false;
          this.availableLimit = allowedLimit - (customer?.chargeAccountDetails?.usedLimit || 0);
          this.hasCreditLimitSection = false;
          if (!this.isRevenueRecognitionSettleEnabled && !this.isUnlimited && this.customerHasChargeAccount && this.availableLimit < this.order.total.unpaid) {
            this.hasCreditLimitSection = true;
          }
        }
      } catch (err) {
        this.helperService.showToaster('error', err);
      } finally {
        this.isFetchingCustomerInfo = false;
      }
    }
  }
  // Charge account info end

  authorizeServiceTooltip(service) {
    if (this.isFinalizedRo) {
      return this.finalizedTooltip;
    } else if (this.openFrom === 'authorize' && (this.order?.isArchived || this.order?.orderStatus === 'invoice')) {
      return this.authorizedTooltip;
    } else if (this.openFrom === 'payment' && (this.order?.isArchived || this.order?.orderStatus === 'invoice' || service?.status === 'inprogress')) {
      return this.paymentTooltip;
    }
  }

  getDriverDetails() {
    if (!this.customerId) return;
    this.httpService.getCustomerDrivers(this.customerId).then(
      (drivers) => {
        // Mark inactive drivers as disabled
        this.drivers = [{ fullName: 'No driver', employeeNumber: null }, ...drivers.map((driver) => ({ ...driver, disabled: !driver.isActive }))];

        // Find and assign the vehicle driver if available
        const driverId = this.vehicle?.driver?._id || this.vehicle?.driver?.driverId;
        if (driverId) {
          this.vehicle.driver = this.drivers.find((driver) => driver?._id === driverId?._id || driver?._id === driverId);
        }

        // Process driver info step
        this.stepProcessor('driverInfoBody');

        // Check if all driver fields are valid
        this.processStepperValue.driverInfoBody = !(this.vehicle?.driver?.fullName && !this.getDriverRequiredValidation());
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  validateDriver(driver: any): boolean {
    this.errors = {}; // Reset error
    let isValid = true;
    if (!driver.fullName) {
      isValid = false;
    }
    const phone = this.helperService.removePhoneFormatting(this.vehicle.driver.phone);
    const email = this.vehicle.driver.email;
    if (phone) {
      if ((phone || '').length < 10) {
        this.errors.phone = `Phone is not valid`;
        isValid = false;
      }
    }
    if (email) {
      if (email && !this.validationService.validateEmail(email)) {
        this.errors.email = 'Email is not valid';
        isValid = false;
      }
    }
    if (this.vehicle?.driver?.address?.zip && !this.isZipCode1Valid) {
      this.errors.zip = 'Zip / Postal Code invalid';
      isValid = false;
    } else {
      this.isZipCode1Valid = true;
    }
    const isFormValid = isValid && this.isZipCode1Valid;
    return isFormValid;
  }

  onUpdate = debounce(() => {
    if (!this.validateDriver(this.vehicle.driver)) {
      return;
    }
    this.vehicle.driver.customerId = this.customerId;
    if (this.vehicle.driver._id) {
      this.httpService
        .updateDriver(this.vehicle?.driver)
        .then((res) => {
          const index = this.drivers.findIndex((driver) => driver._id === res._id);
          if (index) {
            this.drivers[index] = res;
          }
          this.vehicle.driver = res;
          this.onSubmitVehicleInfo();
          this.helperService.showToaster('success', 'Driver updated successfully');
        })
        .catch((err) => {
          this.helperService.showToaster('error', err || 'Error updating driver');
        });
    } else {
      this.httpService
        .createDriver(this.vehicle?.driver)
        .then((res) => {
          this.drivers.push(res);
          this.vehicle.driver = res;
          this.onSubmitVehicleInfo();
          this.helperService.showToaster('success', 'Driver created successfully');
        })
        .catch((err) => {
          this.helperService.showToaster('error', err || 'Error updating driver');
        });
    }
  }, 1000);

  populateCityByZipCode(type: string) {
    this.addressCities = this.allCities;
    let zip = '';

    if (type === 'address') {
      zip = this.vehicle.driver.address.zip;
      this.vehicle.driver.address.zip = this.validationService.formatZip(zip);
    }
    const formattedZip = this.helperService.removeSpaceFromString(zip).toUpperCase();

    this.httpService.getZip(formattedZip).then(
      (res) => {
        if (res) {
          this.isZipCode1Valid = true;
          this.vehicle.driver.address.city = res.city;
          this.vehicle.driver.address.state = res.state;
          this.vehicle.driver.address.stateCode = res.stateCode;
          this.vehicle.driver.address.country = res.country;
          this.onUpdate();
        } else {
          this.vehicle.driver.address.city = '';
          this.vehicle.driver.address.state = '';
          if (type === 'address') {
            this.errors.zip = 'Zip / Postal Code invalid';
            this.isZipCode1Valid = false;
          }
        }
      },
      (error) => {
        if (type === 'address') {
          this.isZipCode1Valid = false;
          this.errors.zip = 'Zip / Postal Code invalid';
        }
      },
    );
  }

  onAddressCitySearch(query: string = '', type: string) {
    if (query) {
      this.httpService.citySearch({ city: this.helperService.trimString(query) }).then(
        (cities) => {
          if (type === 'primary') {
            this.addressCityResults = cities;
          }
        },
        (error) => {
          this.helperService.showToaster('error', this.helperService.getErrorMsg(error));
        },
      );
    }
  }

  onAddressCitySelect(event: any, type: string) {
    this.vehicle.driver.address.city = event.city;
    this.vehicle.driver.address.state = event.state;
    this.vehicle.driver.address.stateCode = event.stateCode;
    this.vehicle.driver.address.country = event.country;
  }

  renderCityName(city: string, stateCode: string) {
    if (city && stateCode) {
      return `${city}, ${stateCode}`;
    }

    return `${city || ''}`;
  }

  onAddressClear(name: string) {
    if (name === 'primary') {
      this.vehicle.driver.address.city = '';
    } else {
      this.addressCityResults = [];
    }
  }

  //To validate Form
  isValidateAuthorizeButton = () => {
    return (this.order && this.order.isArchived) || !this.hasChanges || this.isFinalizedRo || this.getAuthenticationRequiredValidation();
  };

  //To Showing Invoice Button
  showInvoiceButton = () => this.openFrom === 'invoice';

  //To Showing Payment Button
  showPaymentButton = () => this.openFrom === 'payment';

  //To Showing Authorize Button
  showAuthorizeButton = () => this.openFrom === 'authorize' || this.openFrom === 'finalization';

  //To Showing InvoiceQBO Button
  showInvoiceToQBOButton = () => !this.processStepperValue.processAuthorizedBtn && ((this.order && this.order.invoiced) || this.openFrom === 'invoice');

  //Here we disable the options for Approving || Defer || Decline
  disableAuthenticationOptions = () => (this.order && this.order.isArchived) || (this.order && this.order.orderStatus === 'invoice') || this.isFinalizedRo;

  checkDefaultVehicleInfo = () => this.defaultData.mileage == this.data.mileage && this.defaultData.vin == this.data.vin && this.defaultData.mileageOut == this.data.mileageOut;
  /*
  Here we checking only mandatory vin/mileage and show only vehicle info section if vin/mileage are mandatory
  and no service
  */
  checkVehicleInfoWithoutService = () => (this.openFrom === 'invoice' || this.openFrom === 'payment') && this.order && this.order.services && this.order.services.length === 0;

  // Dynamic function to determine if the field is required or optional
  getFieldValidationStatus(fieldKey) {
    // Check if the dynamic key exists and is true
    return this.optionalMFCValidations[fieldKey] === true ? 'required' : 'optional';

    // we are using the below obj to validate the required and optional fields
    // return this.defaultMyFleetValidations[fieldKey] === true ? 'required' : 'optional';
  }

  getErrorMessageValidation(fieldKey) {
    if (this.defaultMyFleetValidations[fieldKey]) {
      const fieldMapping = {
        fullName: this.vehicle?.driver?.fullName,
        serviceCardNumber: this.vehicle?.driver?.serviceCardNumber,
        companyName: this.vehicle?.driver?.companyName,
        poNumber: this.poNumber,
        authorizeNumber: this.authorizeNumber,
        fleetNumber: this.fleetNumber,
        mileage: this.data.mileage,
        mileageOut: this.data.mileageOut,
        unitNumber: this.vehicle.unitNumber,
        licensePlateNo: this.vehicle.licensePlateNo,
        vin: this.data.vin,
        make: this.vehicle.make,
        model: this.vehicle?.model,
        year: this.vehicle?.year,
      };
      // Dynamically check if the field value is missing
      return !fieldMapping[fieldKey] || false;
    }

    return false;
  }

  // ======================================== Driver Classes, validations

  getCreditLimitIconClass() {
    const isCreditLimtRequired = this.hasCreditLimitSection;
    const isCreditLimitCompleted = this.hasSafeToInvoice;

    if (isCreditLimtRequired && !isCreditLimitCompleted) {
      return 'red-warning-icon far fa-exclamation-circle';
    } else if (isCreditLimitCompleted) {
      return 'fas fa-check-circle check-circle-icon text-green';
    } else {
      return 'far fa-exclamation-circle';
    }
  }

  getDriverIconClass() {
    const isDriverRequired = this.getDriverRequiredValidation();
    const isDriverCompleted = this.processStepperValue.driverInfoCompleted;

    if (isDriverRequired && !isDriverCompleted) {
      return 'red-warning-icon far fa-exclamation-circle';
    } else if (isDriverCompleted) {
      return 'fas fa-check-circle check-circle-icon text-green';
    } else {
      return 'far fa-exclamation-circle';
    }
  }

  getDriverRequiredValidation() {
    return ['fullName', 'serviceCardNumber', 'companyName'].some((field) => this.getErrorMessageValidation(field));
  }

  getDriverInfoClass() {
    return this.getDriverRequiredValidation() && !this.processStepperValue.driverInfoCompleted ? 'in-complete' : 'complete';
  }

  getDriverIconType() {
    return this.processStepperValue.driverInfoCompleted ? 'fa-check' : 'fa-exclamation-circle';
  }

  // ======================================== Vehicle Classes, validations

  getVehicleRequiredValidation() {
    return ['year', 'vin', 'unitNumber', 'model', 'mileageOut', 'mileage', 'make', 'licensePlateNo'].some((field) => this.getErrorMessageValidation(field));
  }

  getVinIconClass(): string {
    const isVehicleInfoRequired = this.getVehicleRequiredValidation();
    const isVehicleCompleted = this.processStepperValue.vehicleInfoCompleted;

    if (isVehicleInfoRequired || (!isVehicleInfoRequired && this.requiredVinMilage && !isVehicleCompleted)) {
      return 'text-red red-warning-icon far fa-exclamation-circle';
    }
    if (!isVehicleCompleted && (this.isVinMandatory || this.isMileageMandatory)) {
      return 'far fa-exclamation-circle';
    }
    if (!isVehicleInfoRequired && isVehicleCompleted) {
      return 'fas fa-check-circle check-circle-icon text-green';
    }
    return '';
  }

  getVehicleIconClass() {
    return !this.isVinMandatory && !this.isMileageMandatory && !this.processStepperValue.vehicleInfoCompleted ? 'warning-icon' : '';
  }

  getVehicleIconType() {
    return !this.getVehicleRequiredValidation() && this.processStepperValue.vehicleInfoCompleted
      ? 'fa-check'
      : this.isVinMandatory || this.isMileageMandatory
        ? 'fa-exclamation-circle'
        : 'fa-ellipsis-h';
  }

  getVehicleInfoClass() {
    const isVehicleInfoRequired = this.getVehicleRequiredValidation();

    if (this.validateVehicleInfoStatus()) {
      this.processStepperValue.vehicleInfoCompleted = true;
    }

    return isVehicleInfoRequired || (!isVehicleInfoRequired && this.requiredVinMilage && !this.processStepperValue.vehicleInfoCompleted && this.hasRequiredServiceCheck) ? 'in-complete' : 'complete';
  }

  // ======================================== Authorization Classes, validations

  getAuthenticationRequiredValidation() {
    return ['authorizeNumber', 'poNumber', 'fleetNumber'].some((field) => this.getErrorMessageValidation(field));
  }

  getAuthorizationClass() {
    return this.openFrom === 'payment' ? 'complete' : this.getAuthenticationRequiredValidation() || !this.processStepperValue.authorizationCompleted ? 'in-complete' : 'complete';
  }

  getSalesCodeClass() {
    return this.showAuthorizeButton() || this.showPaymentButton() ? 'complete' : !this.processStepperValue.salesCodeCompleted ? 'in-complete' : 'complete';
  }

  getAuthorizationIconType() {
    return this.processStepperValue.authorizationCompleted ? 'fa-check' : 'fa-exclamation-circle';
  }

  getSalesCodeIconType() {
    return this.processStepperValue.salesCodeCompleted ? 'fa-check' : 'fa-exclamation-circle';
  }

  getAuthorizationIconClass() {
    const isAuthenticationRequired = this.getAuthenticationRequiredValidation();
    const isAuthenticationCompleted = this.processStepperValue.authorizationCompleted;

    if (this.openFrom === 'payment' && !isAuthenticationCompleted) {
      return 'far fa-exclamation-circle';
    } else if (!isAuthenticationCompleted || isAuthenticationRequired) {
      return 'text-red far fa-exclamation-circle red-warning-icon';
    } else {
      return 'fas fa-check-circle check-circle-icon';
    }
  }

  getSalesCodeIconClass() {
    if ((this.showAuthorizeButton() || this.showPaymentButton()) && !this.processStepperValue.salesCodeCompleted) {
      return 'far fa-exclamation-circle';
    } else if (!this.processStepperValue.salesCodeCompleted) {
      return 'text-red far fa-exclamation-circle red-warning-icon';
    } else {
      return 'fas fa-check-circle check-circle-icon';
    }
  }

  getWarrantyIconClass() {
    if ((this.showAuthorizeButton() || this.showPaymentButton()) &&
      !this.processStepperValue.warrantyCompleted) {
      return 'far fa-exclamation-circle';
    } else if (!this.processStepperValue.warrantyCompleted) {
      return 'text-red far fa-exclamation-circle red-warning-icon';
    } else {
      return 'fas fa-check-circle check-circle-icon';
    }
  }

  getWarrantyClass = () => this.showAuthorizeButton() ? 'complete' : !this.processStepperValue.warrantyCompleted ? 'in-complete' : 'complete';

  getWarrantyIconType = () => this.processStepperValue.warrantyCompleted ? 'fa-check' : 'fa-exclamation-circle';

  showEllipsisIcon(): boolean {
    return !this.processingVin && !this.isVinMandatory && !this.isMileageMandatory && !this.processStepperValue.vehicleInfoCompleted;
  }

  postToMyFleet(isPostToFleet = false) {
    const data = {
      postToMyFleetCenter: true,
    };
    if (isPostToFleet) {
      const payload = {
        orderId: this.estimateId,
      };
      this.isLoading = true;
      this.httpService
        .postToMyFleetCenter(payload)
        .then((response) => {
          this.isLoading = false;
          this.dynamicDialogRef.close({ data });
          this.helperService.showToaster('success', response);
        })
        .catch((err) => {
          this.helperService.showToaster('error', err);
          this.isLoading = false;
        });
    } else {
      this.dynamicDialogRef.close({ data });
    }
  }

  appendEmptyCodeDisplays(): string {
    return (
      this.customer?.MFC &&
      this.customer?.MFC?.requirements
        .filter((item) => item.code === '') // Filter items with empty code
        .map((item) => item.display)
        .join('\n')
    ); // Join them with line breaks
  }

  isValidPostToMyFleetButton() {
    // Return true (disable the button) if any of the validation functions return true
    if (this.MFCValidations) {
      return this.hasPendingServices || this.getVehicleRequiredValidation() || this.getDriverRequiredValidation() || this.getAuthenticationRequiredValidation();
    }
    return false; // If no validations are required, keep the button enabled
  }

  handleSafeToInvoice = () => (this.hasSafeToInvoice = true);
  isValidSafeToInvoice = () => !this.isRevenueRecognitionSettleEnabled && !this.hasSafeToInvoice && this.hasCreditLimitSection;
}
